import { defineMessages } from 'react-intl'

export interface Message {
  id: string
  defaultMessage: string
}

export const messages = defineMessages({
  SEMICONF_PURIFICATION_HELP_TEXT_ONE: {
    id: 'PURIFICATION_HELP_TEXT_ONE',
    defaultMessage:
      'Standard sgRNAs are purified via reverse-phase cartridge chromatography which separates the full-length sequence from shortmers and truncated sequences generated during the synthesis process. Standard purification sgRNAs work in numerous CRISPR applications over a range of model systems.',
  },
  SEMICONF_PURIFICATION_HELP_TEXT_TWO: {
    id: 'PURIFICATION_HELP_TEXT_TWO',
    defaultMessage:
      'PURedit™ sgRNAs are purified via HPLC, which provides the highest, most consistent quality sgRNAs by precisely purifying out truncated sequences based on only a few base changes. For applications requiring high quality reagents, PURedit™ sgRNAs are the best choice.',
  },
  SEMICONF_GENE_SYMBOL_kicqstartPrimers: {
    id: 'SEMICONF_GENE_SYMBOL_kicqstartPrimers',
    defaultMessage: 'Gene Symbol',
  },
  SEMICONF_GENE_ID_kicqstartPrimers: {
    id: 'SEMICONF_GENE_ID_kicqstartPrimers',
    defaultMessage: 'Gene ID',
  },
  SEMICONF_REFSEQ_ID_kicqstartPrimers: {
    id: 'SEMICONF_REFSEQ_ID_kicqstartPrimers',
    defaultMessage: 'RefSeq ID',
  },
  SEMICONF_SPECIES_kicqstartPrimers: {
    id: 'SEMICONF_SPECIES_kicqstartPrimers',
    defaultMessage: 'Species',
  },
  SEMICONF_QUANTITY_kicqstartPrimers: {
    id: 'SEMICONF_QUANTITY_kicqstartPrimers',
    defaultMessage: 'Quantity',
  },
  SEMICONF_CONFIRM_ORDER_Kicqstart: {
    id: 'SEMICONF_CONFIRM_ORDER_Kicqstart',
    defaultMessage: 'Review & Confirm',
  },
  CONF_DELETE_ALL_BUTTON: {
    id: 'CONF_DELETE_ALL_BUTTON',
    defaultMessage: 'Delete All ',
  },
  _PC_QUOTE_ITEM: { id: '_PC_QUOTE_ITEM', defaultMessage: 'Quote Item' },
  //Message returned as endpoint error. Do not modify or delete key.
  USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED: {
    id: 'USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED',
    defaultMessage:
      'You are not authorized or Your user session has expired. Sign in to continue.',
  },
  CART_SUMMARY: { id: 'CART_SUMMARY', defaultMessage: 'Summary' },
  CART_QUOTATION_TEXT: {
    id: 'CART_QUOTATION_TEXT',
    defaultMessage:
      'Pricing can not be calculated. Add to cart to submit your quotation request.',
  },
  CONF_NOTE: { id: 'CONF_NOTE', defaultMessage: 'Note: ' },
  CONF_PRICE_SUB_TOTAL: {
    id: 'CONF_PRICE_SUB_TOTAL',
    defaultMessage: 'Price displayed is a subtotal amount.',
  },
  CONF_APPLICATIONFREIGHT_TAX: {
    id: 'CONF_APPLICATIONFREIGHT_TAX',
    defaultMessage:
      'Applicable freight, taxes and fees will be added at checkout.',
  },
  CONF_PROMOTIONAL_CODES: {
    id: 'CONF_PROMOTIONAL_CODES',
    defaultMessage: 'Promotional codes can be added at checkout',
  },
  CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna: {
    id: 'CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna',
    defaultMessage: 'Synthetic RNA',
  },
  SEMICONF_PAGINATION_SHOWING_TEXT_crisprgrna: {
    id: 'SEMICONF_PAGINATION_SHOWING_TEXT_crisprgrna',
    defaultMessage: 'Showing',
  },
  SEMICONF_PAGINATION_OF_TEXT_crisprgrna: {
    id: 'SEMICONF_PAGINATION_OF_TEXT_crisprgrna',
    defaultMessage: 'of',
  },
  SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna: {
    id: 'SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna',
    defaultMessage: 'Results',
  },
  SEMICONF_SELECT_PRIMER_PAIR_ERROR: {
    id: 'SEMICONF_SELECT_PRIMER_PAIR_ERROR',
    defaultMessage:
      'Please select at least one primer pair before proceeding to next step.',
  },
  SEMICONF_SELECT_PRIMER_PAIRS_kicqstartPrimers: {
    id: 'SEMICONF_SELECT_PRIMER_PAIRS_kicqstartPrimers',
    defaultMessage: 'Select Primer Pairs',
  },
  SEMICONF_NO_RECORDS_MSG_crisprgrna: {
    id: 'SEMICONF_NO_RECORDS_MSG_crisprgrna',
    defaultMessage: 'No records matches the current criteria.',
  },
  CONTINUE: { id: 'CONTINUE', defaultMessage: 'Continue' },
  SEMICONF_FILTER_LABEL_kicqstartPrimers: {
    id: 'SEMICONF_FILTER_LABEL_kicqstartPrimers',
    defaultMessage: 'Filter by Species',
  },
  SEMI_CONF_PER_PAGE_crispgrna: {
    id: 'SEMI_CONF_PER_PAGE_crispgrna',
    defaultMessage: 'Per Page',
  },
  SEMICONF_PRIMER_PAIR_ID_kicqstartPrimers: {
    id: 'SEMICONF_PRIMER_PAIR_ID_kicqstartPrimers',
    defaultMessage: 'Primer Pair ID',
  },
  SEMICONF_EXONS: { id: 'SEMICONF_EXONS', defaultMessage: 'Exons' },
  SEMICONF_RANK_kicqstartPrimers: {
    id: 'SEMICONF_RANK_kicqstartPrimers',
    defaultMessage: 'Rank',
  },
  SEMICONF_PRICE_kicqstartPrimers: {
    id: 'SEMICONF_PRICE_kicqstartPrimers',
    defaultMessage: 'Price',
  },
  HOME: { id: 'HOME', defaultMessage: 'Home' },
  SEMICONF_BREADCRUMB_kicqstartPrimers: {
    id: 'SEMICONF_BREADCRUMB_kicqstartPrimers',
    defaultMessage: 'Custom Products',
  },
  SEMICONF_BREADCRUMB2_kicqstartPrimers: {
    id: 'SEMICONF_BREADCRUMB2_kicqstartPrimers',
    defaultMessage: 'Oligos & Probes',
  },
  SEMICONF_BREADCRUMB3_kicqstartPrimers: {
    id: 'SEMICONF_BREADCRUMB3_kicqstartPrimers',
    defaultMessage: 'KiCqStart™ Primers',
  },
  SEMICONF_SEARCH_PRIMER_PAIRS_kicqstartPrimers: {
    id: 'SEMICONF_SEARCH_PRIMER_PAIRS_kicqstartPrimers',
    defaultMessage: 'Search Primer Pairs',
  },
  SEMICONF_REVIEW_AND_CONFIRM_kicqstartPrimers: {
    id: 'SEMICONF_REVIEW_AND_CONFIRM_kicqstartPrimers',
    defaultMessage: 'Review & Confirm',
  },
  SEMICONF_LABEL_HEADER_kicqstartPrimers: {
    id: 'SEMICONF_LABEL_HEADER_kicqstartPrimers',
    defaultMessage: 'KiCqStart™ Primers ',
  },
  CONF_DNAPLATES_ERROR_STEP2: {
    id: 'CONF_DNAPLATES_ERROR_STEP2',
    defaultMessage:
      'Please correct the error(s) before proceeding to the next step.',
  },
  CONF_MANUAL_SEARCH_1_ERROR_POPUP_crispgrna: {
    id: 'CONF_MANUAL_SEARCH_1_ERROR_POPUP_crispgrna',
    defaultMessage: 'We are sorry, but your search query "',
  },
  CONF_MANUAL_SEARCH_2_ERROR_POPUP_crispgrna: {
    id: 'CONF_MANUAL_SEARCH_2_ERROR_POPUP_crispgrna',
    defaultMessage:
      '" returned no results. Please review your query and try again.',
  },
  CONF_REQUIRED_FIELD: {
    id: 'CONF_REQUIRED_FIELD',
    defaultMessage: 'Required Field',
  },
  CONF_UPLOAD_ERROR_MSG: {
    id: 'CONF_UPLOAD_ERROR_MSG',
    defaultMessage: 'Maximum number of items per session is 100.',
  },
  SEMICONF_MAX_ITEMS_ALLOWED: {
    id: 'SEMICONF_MAX_ITEMS_ALLOWED',
    defaultMessage: 'Maximum number of items per session is {maxItems}.',
  },
  SEMICONF_INSTRUCTIONS_kicqstartPrimers: {
    id: 'SEMICONF_INSTRUCTIONS_LABEL_kicqstartPrimers',
    defaultMessage:
      "Search by Gene Symbol, mRNA RefSeq, Gene ID or Primer Pair ID and select 'Search'. Enter up to 100 items separated by spaces. Searches are performed on the highlighted tab only. ",
  },
  SEARCH: { id: 'SEARCH', defaultMessage: 'Search' },
  CONF_INVALID_TEMPLATE: {
    id: 'CONF_INVALID_TEMPLATE',
    defaultMessage:
      'The file you have uploaded is invalid. Try again using the template provided.',
  },
  CONF_EMPTY_FILE: {
    id: 'CONF_EMPTY_FILE',
    defaultMessage: 'The uploaded file is empty.',
  },
  CONF_INVALID_FORMAT: {
    id: 'CONF_INVALID_FORMAT',
    defaultMessage: 'Invalid format. Please check the template and try again.',
  },
  SEMICONF_INSTRUCTIONS_LABEL_kicqstartPrimers: {
    id: 'SEMICONF_INSTRUCTIONS_kicqstartPrimers',
    defaultMessage: 'Instructions',
  },
  SEMICONF_DOWNLOAD_LABEL_kicqstartPrimers: {
    id: 'SEMICONF_DOWNLOAD_LABEL_kicqstartPrimers',
    defaultMessage: 'Download the Ordering Template',
  },
  SEMICONF_UPLOAD_INSTRUCTION_kicqstartPrimers: {
    id: 'SEMICONF_UPLOAD_INSTRUCTION_kicqstartPrimers',
    defaultMessage: ' and enter your specifications.',
  },
  SEMICONF_UPLOAD_TEXT_kicqstartPrimers: {
    id: 'SEMICONF_UPLOAD_TEXT_kicqstartPrimers',
    defaultMessage: 'Upload your saved genes file below (.xlsx format only)',
  },
  DROP_CSV_XLS_FILE_OR: {
    id: 'DROP_CSV_XLS_FILE_OR',
    defaultMessage: 'Drag and drop your CSV or XLS file to upload or',
  },
  CONF_DOWNLOAD_PRINT_SUMMARY: {
    id: 'CONF_DOWNLOAD_PRINT_SUMMARY',
    defaultMessage: 'Download Summary ',
  },
  CONF_GENE_ID_LABEL_crispgrna: {
    id: 'CONF_GENE_ID_LABEL_crispgrna',
    defaultMessage: 'Gene ID',
  },
  CONF_GENE_SYM_LABEL_crispgrna: {
    id: 'CONF_GENE_SYM_LABEL_crispgrna',
    defaultMessage: 'Gene Symbol',
  },
  CONF_EFFICIENCY_SCORE_LABEL_crispgrna: {
    id: 'CONF_EFFICIENCY_SCORE_LABEL_crispgrna',
    defaultMessage: 'Efficiency Score',
  },
  CONF_SPECIFICATION_SCORE_LABEL_crispgrna: {
    id: 'CONF_SPECIFICATION_SCORE_LABEL_crispgrna',
    defaultMessage: 'Specificity Score',
  },
  CONF_SPECIES_crisprgrna: {
    id: 'CONF_SPECIES_crisprgrna',
    defaultMessage: 'Species',
  },
  SEMICONF_RECOMMENDED_STATUS_crisprgrna: {
    id: 'SEMICONF_RECOMMENDED_STATUS_crisprgrna',
    defaultMessage: 'Recommended Status',
  },
  CONF_CONFIRM_ORDER_DNA_PLATES: {
    id: 'CONF_CONFIRM_ORDER_DNA_PLATES',
    defaultMessage: 'Confirm Order',
  },
  CONF_DNAPLATES_ORDER_SUMMARY: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY',
    defaultMessage: 'Order Summary',
  },
  CONF_SPECIFICATION_PHYSICAL_MATERIAL: {
    id: 'CONF_SPECIFICATION_PHYSICAL_MATERIAL',
    defaultMessage: 'Physical Material',
  },
  CONF_SPECIFICATION_STRUCTURE_crisprgrna: {
    id: 'CONF_SPECIFICATION_STRUCTURE_crisprgrna',
    defaultMessage: 'Structure',
  },
  SEMICONF_SCALE_OF_SYNTHESIS_crisprgrna: {
    id: 'SEMICONF_SCALE_OF_SYNTHESIS_crisprgrna',
    defaultMessage: 'Scale of Synthesis',
  },
  CONF_DNAPLATES_MODIFICATIONS: {
    id: 'CONF_DNAPLATES_MODIFICATIONS',
    defaultMessage: 'Modifications:',
  },
  CONF_SPECIFICATION_PURIFICATION_crisprgrna: {
    id: 'CONF_SPECIFICATION_PURIFICATION_crisprgrna',
    defaultMessage: 'Purification',
  },
  CONF_DNA_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_SPECIFICATION_crispgrna',
    defaultMessage: 'Vector',
  },
  CONF_AMOUNT_DNA_SPECIFICATION_crispgrna: {
    id: 'CONF_AMOUNT_DNA_SPECIFICATION_crispgrna',
    defaultMessage: 'Amount',
  },
  CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna',
    defaultMessage: 'Lentivirus Backbone',
  },
  SEMICONF_VIRAL_TITER_crisprgrna: {
    id: 'SEMICONF_VIRAL_TITER_crisprgrna',
    defaultMessage: 'Viral Titer:',
  },
  CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna',
    defaultMessage: 'Volume',
  },
  CONF_SPEC_ALIQUOTING_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_sangercrisprclones',
    defaultMessage: 'Aliquoting',
  },
  CONF_AMBIENT_ROOM_TEMP: {
    id: 'CONF_AMBIENT_ROOM_TEMP',
    defaultMessage: 'Ambient (Room Temperature)',
  },
  SEMICONF_DRY_ICE_crispr: {
    id: 'SEMICONF_DRY_ICE_crispr',
    defaultMessage: 'Dry Ice',
  },
  SEMICONF_SUBTOTAL_CHECK_BOX_crisprgrna: {
    id: 'SEMICONF_SUBTOTAL_CHECK_BOX_crisprgrna',
    defaultMessage:
      ' SygRNA® CRISPR crRNA requires tracrRNA for correct gene editing function.Please click to confirm you are aware of this requirement.',
  },
  CONF_SELECT_REQUIRED_FIELD_crispgrna: {
    id: 'CONF_SELECT_REQUIRED_FIELD_crispgrna',
    defaultMessage: 'Please select the Required Fields',
  },
  CONF_SPECIFICATIONS_crisprgrna: {
    id: 'CONF_SPECIFICATIONS_crisprgrna',
    defaultMessage: 'Specifications',
  },
  CONF_SPECIFICATION_CRISPR_SPECIES_crisprgrna: {
    id: 'CONF_SPECIFICATION_CRISPR_SPECIES_crisprgrna',
    defaultMessage: 'CRISPR Species',
  },
  CONF_SPECIFICATION_CRISPR_SPECIES_SpCas9_crisprgrna: {
    id: 'CONF_SPECIFICATION_CRISPR_SPECIES_SpCas9_crisprgrna',
    defaultMessage: 'SpCas9',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_crisprgrna: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_crisprgrna',
    defaultMessage: 'Synthesis Scale',
  },
  CONF_SPECIFICATION_MODIFIED_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_crisprgrna',
    defaultMessage: 'Modified',
  },
  CONF_SPECIFICATION_MODIFIED_HELP_TEXT_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_HELP_TEXT_crisprgrna',
    defaultMessage:
      "Chemically modified synthetic gRNA contain stabilizing 2'-O-methyl and phosphorothioate linkages",
  },
  CONF_SPECIFICATION_MODIFIED_YES_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_YES_crisprgrna',
    defaultMessage: 'Yes',
  },
  CONF_SPECIFICATION_MODIFIED_NO_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_NO_crisprgrna',
    defaultMessage: 'No',
  },
  CONF_SPECIFICATION_FORMAT_crisprgrna: {
    id: 'CONF_SPECIFICATION_FORMAT_crisprgrna',
    defaultMessage: 'Format',
  },
  CONF_SPECIFICATION_DRY_crisprgrna: {
    id: 'CONF_SPECIFICATION_DRY_crisprgrna',
    defaultMessage: 'Dry',
  },
  CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna',
    defaultMessage: 'View vector maps and features at',
  },
  CONF_DNA_LINK_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_LINK_SPECIFICATION_crispgrna',
    defaultMessage: ' CRISPR Essentials',
  },
  CONF_DNA_LINK_SPECIFICATION_shrna: {
    id: 'CONF_DNA_LINK_SPECIFICATION_shrna',
    defaultMessage: ' Vector Maps ',
  },
  SEMICONF_HELP_ICON_TEXT_AMOUNT_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_AMOUNT_crisprgrna',
    defaultMessage:
      '1 ug is provided at 20 ng/ul; all other amounts will have concentration reported with product',
  },
  CONF_VIRUS_TITER_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_TITER_SPECIFICATION_crispgrna',
    defaultMessage: 'Titer',
  },
  SEMICONF_HELP_ICON_TEXT_TITER_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_TITER_crisprgrna',
    defaultMessage:
      'The concentration of lentivirus particles, measured by p24 ELISA',
  },
  SEMICONF_HELP_ICON_TEXT_VOLUME_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_VOLUME_crisprgrna',
    defaultMessage: 'The total volume of lentivirus provided',
  },
  CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna',
    defaultMessage: 'Aliquoting',
  },
  SEMICONF_HELP_ICON_TEXT_ALIQUOTING_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_ALIQUOTING_crisprgrna',
    defaultMessage: 'The number of vials and aliquot volume in each vial',
  },
  CONF_SEARCH_TERMS: {
    id: 'CONF_SEARCH_TERMS',
    defaultMessage: 'Search Terms',
  },
  CONF_GRNA_CATEGORY_crispgrna: {
    id: 'CONF_GRNA_CATEGORY_crispgrna',
    defaultMessage: 'gRNA Category',
  },
  SEMI_CONF_TOP_CHOICE_crispgrna: {
    id: 'SEMI_CONF_TOP_CHOICE_crispgrna',
    defaultMessage: 'Top Choice',
  },
  SEMI_CONF_POSITIVE_CONTROL_crispgrna: {
    id: 'SEMI_CONF_POSITIVE_CONTROL_crispgrna',
    defaultMessage: 'Positive Control',
  },
  SEMI_CONF_NEGATIVE_CONTROL_crispgrna: {
    id: 'SEMI_CONF_NEGATIVE_CONTROL_crispgrna',
    defaultMessage: 'Negative Control',
  },
  CONF_MISSION_GRNA_ID_LABEL_crispgrna: {
    id: 'CONF_MISSION_GRNA_ID_LABEL_crispgrna',
    defaultMessage: 'MISSION ™ gRNA ID',
  },
  CONF_SPECIES_LABEL_crispgrna: {
    id: 'CONF_SPECIES_LABEL_crispgrna',
    defaultMessage: 'Species',
  },
  SEMICONF_DETAILS_SEQUENCE_crisprgrna: {
    id: 'SEMICONF_DETAILS_SEQUENCE_crisprgrna',
    defaultMessage: "Sequence (5'-3'):",
  },
  SEMICONF_DETAILS_STRAND_crisprgrna: {
    id: 'SEMICONF_DETAILS_STRAND_crisprgrna',
    defaultMessage: 'Strand:',
  },
  SEMICONF_DETAILS_PAM_crisprgrna: {
    id: 'SEMICONF_DETAILS_PAM_crisprgrna',
    defaultMessage: 'PAM:',
  },
  SEMICONF_DETAILS_TRANSCRIPTS_HIT_crisprgrna: {
    id: 'SEMICONF_DETAILS_TRANSCRIPTS_HIT_crisprgrna',
    defaultMessage: 'Transcripts Hit:',
  },
  SEMICONF_DETAILS_START_COORDINATE_crisprgrna: {
    id: 'SEMICONF_DETAILS_START_COORDINATE_crisprgrna',
    defaultMessage: 'Start Coordinate:',
  },
  SEMICONF_DETAILS_REFSEQ_crisprgrna: {
    id: 'SEMICONF_DETAILS_REFSEQ_crisprgrna',
    defaultMessage: 'Refseq/Exon:',
  },
  SEMICONF_DETAILS_CHROMOSOME_crisprgrna: {
    id: 'SEMICONF_DETAILS_CHROMOSOME_crisprgrna',
    defaultMessage: 'Chromosome:',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_crisprgrna',
    defaultMessage:
      'Predesigned gRNAs are recommended for KO applications based on the following design criteria:',
  },
  SEMICONF_HELP_ICON_TEXT_EFFICIENCY_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_EFFICIENCY_crisprgrna',
    defaultMessage: 'Efficiency score from Doench, Fusi et al. (2016)',
  },
  SEMICONF_HELP_ICON_TEXT_SPECIFICITY_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SPECIFICITY_crisprgrna',
    defaultMessage: 'Specificity score from Hsu et al.  (2013)',
  },
  CONF_GRNA_ERROR_POPUP_crispgrna: {
    id: 'CONF_GRNA_ERROR_POPUP_crispgrna',
    defaultMessage:
      'Please select either Predesigned Controls or Predesigned gRNAs before proceeding to next step',
  },
  CONF_Crispr_Search_Criteria_crisprgrna: {
    id: 'CONF_Crispr_Search_Criteria_crisprgrna',
    defaultMessage: 'Search Criteria',
  },
  CONF_Pre_Designed_Control_crisprgrna: {
    id: 'CONF_Pre_Designed_Control_crisprgrna',
    defaultMessage: 'Predesigned Controls',
  },
  CONF_Pre_Designed_gRNA_crisprgrna: {
    id: 'CONF_Pre_Designed_gRNA_crisprgrna',
    defaultMessage: 'Predesigned gRNAs',
  },
  CONF_FILTER_RESULT_crisprgrna: {
    id: 'CONF_FILTER_RESULT_crisprgrna',
    defaultMessage: 'Filter Results',
  },
  CONF_HUMAN: { id: 'CONF_HUMAN', defaultMessage: 'Human' },
  CONF_HUMAN_crisprgrna: {
    id: 'CONF_HUMAN_crisprgrna',
    defaultMessage: 'Human',
  },
  CONF_MOUSE: { id: 'CONF_MOUSE', defaultMessage: 'Mouse' },
  CONF_MOUSE_crisprgrna: {
    id: 'CONF_MOUSE_crisprgrna',
    defaultMessage: 'Mouse',
  },
  SEMI_CONF_SORTBY_crispgrna: {
    id: 'SEMI_CONF_SORTBY_crispgrna',
    defaultMessage: 'Sort By',
  },
  SEMICONF_BREADCRUMB1_sirna: {
    id: 'SEMICONF_BREADCRUMB1_sirna',
    defaultMessage: 'Custom Products',
  },
  CONF_CUSTOM_PRODUCT_NAME_CUSTOMCRISPR: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_CUSTOMCRISPR',
    defaultMessage: 'CRISPR & Gene Editing',
  },
  CONF_CRISPR_gRNA_HEADER_crisprgrna: {
    id: 'CONF_CRISPR_gRNA_HEADER_crisprgrna',
    defaultMessage: 'Guaranteed Predesigned CRISPR gRNA',
  },
  CONF_PRODUCT_SEARCH: {
    id: 'CONF_PRODUCT_SEARCH',
    defaultMessage: 'Product Search',
  },
  CONF_ITEM_SELECTION: {
    id: 'CONF_ITEM_SELECTION',
    defaultMessage: 'Select Clones',
  },
  CONF_REVIEW_ORDER_crisprgrna: {
    id: 'CONF_REVIEW_ORDER_crisprgrna',
    defaultMessage: 'Review & Confirm',
  },
  CONF_SEARCH_GENES: {
    id: 'CONF_SEARCH_GENES',
    defaultMessage: 'Search Genes',
  },
  CONF_SEARCH_TERM: { id: 'CONF_SEARCH_TERM', defaultMessage: 'Search Term' },
  CONF_SEARCH_MESSAGE_crisprgrna: {
    id: 'CONF_SEARCH_MESSAGE_crisprgrna',
    defaultMessage:
      'Search by Gene Symbol, Gene ID or MISSION™ gRNA ID (Enter up to 100 items separated by spaces)',
  },
  order_field_label_search_orders: {
    id: 'order_field_label_search_orders',
    defaultMessage: 'Search',
  },
  CONF_OPTIONAL_INTR_MOD_TEMPLATE_standard: {
    id: 'CONF_OPTIONAL_INTR_MOD_TEMPLATE_standard',
    defaultMessage:
      'Follow these steps below to quickly upload multiple entries using a pre-defined template.',
  },
  CONF_MULTIPLE_ENTRY_STEP_1: {
    id: 'CONF_MULTIPLE_ENTRY_STEP_1',
    defaultMessage: 'Download the Multiple Entry Template',
  },
  CONF_MULTIPLE_ENTRY_STEP_2: {
    id: 'CONF_MULTIPLE_ENTRY_STEP_2',
    defaultMessage:
      'Enter your specifications in the provided spreadsheet template.',
  },
  CONF_FILE_UPLOAD_crispgrna: {
    id: 'CONF_FILE_UPLOAD_crispgrna',
    defaultMessage: 'Upload your saved sequence file here (.xls format only) ',
  },
  CONF_DNAPLATES_PLATE_TYPE: {
    id: 'CONF_DNAPLATES_PLATE_TYPE',
    defaultMessage: 'Plate Type',
  },
  CONF_DNAPLATES_PLATE: { id: 'CONF_DNAPLATES_PLATE', defaultMessage: 'Plate' },
  SEMICONF_KICQSTART_GENE_ARRAY_PLATE_PAIRS: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_PLATE_PAIRS',
    defaultMessage: 'Plate {plateIndex}: {pair} Primer Pairs',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_ADD_PLATE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_ADD_PLATE',
    defaultMessage: 'Add a Plate',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_INFORMATION: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_INFORMATION',
    defaultMessage: 'Array Information',
  },
  SEMICONF_ZOOMOUT: { id: 'SEMICONF_ZOOMOUT', defaultMessage: 'Zoom Out' },
  SEMICONF_GENE_ARRAY_PLATE_NAME: {
    id: 'SEMICONF_GENE_ARRAY_PLATE_NAME',
    defaultMessage: 'PLATE {id}',
  },
  SEMICONF_GENE_ARRAY_FILLED_WELL: {
    id: 'SEMICONF_GENE_ARRAY_FILLED_WELL',
    defaultMessage: 'Filled Well',
  },
  SEMICONF_GENE_ARRAY_EMPTY_WELL: {
    id: 'SEMICONF_GENE_ARRAY_EMPTY_WELL',
    defaultMessage: 'Empty Well',
  },
  SEMICONF_GENE_ARRAY_DELETE_PLATE: {
    id: 'SEMICONF_GENE_ARRAY_DELETE_PLATE',
    defaultMessage: 'Delete Plate',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELLDETAILS_SEARCH_ERROR_MESSAGE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELLDETAILS_SEARCH_ERROR_MESSAGE',
    defaultMessage:
      'Please enter a Gene Symbol, Reference Sequence, or Gene ID to find primer pairs.',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELLDETAILS_UPDATE_ERROR_MESSAGE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELLDETAILS_UPDATE_ERROR_MESSAGE',
    defaultMessage: 'Please select one Primer Pair.',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_SELECT_PRIMER_PAIR: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_SELECT_PRIMER_PAIR',
    defaultMessage: 'Select Primer Pair',
  },
  SEMI_CONF_REF_SEQ_ID: {
    id: 'SEMI_CONF_REF_SEQ_ID',
    defaultMessage: 'Ref Seq ID',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_ID: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_ID',
    defaultMessage: 'WELL ID ',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_GENE_SYMBOL: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_GENE_SYMBOL',
    defaultMessage: 'Enter Gene Symbol',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_OR_SPERATOR: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_OR_SPERATOR',
    defaultMessage: 'OR',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_SEQUENCE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_SEQUENCE',
    defaultMessage: 'Enter Reference Sequence',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_GENE_ID: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_GENE_ID',
    defaultMessage: 'Enter Gene ID',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_SELECT_SPECIES: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_WELL_DETAILS_SELECT_SPECIES',
    defaultMessage: 'Select the Species',
  },
  CONF_DNAPLATES_CLEAR_WELL: {
    id: 'CONF_DNAPLATES_CLEAR_WELL',
    defaultMessage: 'Clear Well',
  },
  CONF_DNAPLATES_UPDATE_WELL: {
    id: 'CONF_DNAPLATES_UPDATE_WELL',
    defaultMessage: 'Update Well',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_MAXIMUM_PLATE_ERROR_MESSAGE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_MAXIMUM_PLATE_ERROR_MESSAGE',
    defaultMessage:
      'The maximum number of plates that can be added is {noOfMaxPlates}',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_MINIMUM_WELLDETAILS_ERROR_MESSAGE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_MINIMUM_WELLDETAILS_ERROR_MESSAGE',
    defaultMessage: 'requires a minimum of 3 primer pairs.',
  },
  PREVIOUS_STEP: { id: 'PREVIOUS_STEP', defaultMessage: 'Previous Step' },
  SEMICONF_SPECIES_siRNA: {
    id: 'SEMICONF_SPECIES_siRNA',
    defaultMessage: 'Species',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_NUMBER_PRIMER_PLATE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_NUMBER_PRIMER_PLATE',
    defaultMessage: 'Total Number of Primer Pairs in Plate:',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_NUMBER_PRIMER_ARRAY: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_NUMBER_PRIMER_ARRAY',
    defaultMessage: 'Total Number of Primer Pairs in Array:',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_CUSTOM_PRODUCT_TEXT: {
    id: 'SEMICONF_BREADCRUMB_kicqstartPrimers',
    defaultMessage: 'Custom Products',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_OLIGO_PROBE_TEXT: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_OLIGO_PROBE_TEXT',
    defaultMessage: 'Oligos & Probes',
  },
  SEMICONF_KICQSTART_GENE_ARRAY: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY',
    defaultMessage: 'KiCqStart{registered} Primers Gene Arrays',
  },
  CONF_TRADEMARK: { id: 'CONF_TRADEMARK', defaultMessage: '®' },
  SEMICONF_KICQSTART_GENE_ARRAY_SEARCH_ARRAY: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_SEARCH_ARRAY',
    defaultMessage: 'Search Array',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_SELECT_SPECIES: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_SELECT_SPECIES',
    defaultMessage: 'Select Species, Plates & Configure',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_REVIEW_CONFIRM: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_REVIEW_CONFIRM',
    defaultMessage: 'Review & Add to Cart',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_NAME_ERROR_MESSAGE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_NAME_ERROR_MESSAGE',
    defaultMessage:
      'Invalid array name. Please select from the pull down menu.',
  },
  SEMI_CONF_MATCH_TYPE: {
    id: 'SEMI_CONF_MATCH_TYPE',
    defaultMessage: 'Match Type',
  },
  SEMI_CONF_GENE_SYM: { id: 'SEMI_CONF_GENE_SYM', defaultMessage: 'Gene Sym' },
  SEMI_CONF_ORF_GENE_ID: {
    id: 'SEMI_CONF_ORF_GENE_ID',
    defaultMessage: 'Gene ID',
  },
  SEMI_CONF_ORF_LENGTH: {
    id: 'SEMI_CONF_ORF_LENGTH',
    defaultMessage: 'ORF Length',
  },
  SEMI_CONF_ORF_REVIEW_CONFIRM: {
    id: 'SEMI_CONF_ORF_REVIEW_CONFIRM',
    defaultMessage: 'Review & Confirm',
  },
  SEMI_CONF_DELETE_ALL_BUTTON: {
    id: 'SEMI_CONF_DELETE_ALL_BUTTON',
    defaultMessage: 'Delete All ',
  },
  SEMI_CONF_SPECIFICATION_ORF: {
    id: 'SEMI_CONF_SPECIFICATION_ORF',
    defaultMessage: 'Specifications',
  },
  CONF_SPEC_VIRAL_TITER: {
    id: 'CONF_SPEC_VIRAL_TITER',
    defaultMessage: 'Viral Titer',
  },
  CONF_SPEC_VOLUME_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_sangercrisprclones',
    defaultMessage: 'Volume',
  },
  SEMICONF_SUBTOTAL_ORF: {
    id: 'SEMICONF_SUBTOTAL_ORF',
    defaultMessage: 'Subtotal',
  },
  CONF_POINT_ONE_DNA_PLATES: {
    id: 'CONF_POINT_ONE_DNA_PLATES',
    defaultMessage:
      'Applicable freight, taxes and fees will be added at checkout',
  },
  CONF_SPECIFICATIONS_sangerCrispr: {
    id: 'CONF_SPECIFICATIONS_sangerCrispr',
    defaultMessage: 'Specifications',
  },
  CONF_SPEC_SANGER_GLYCEROL_sangercrisprclones: {
    id: 'CONF_SPEC_SANGER_GLYCEROL_sangercrisprclones',
    defaultMessage: 'Sanger Bacterial Glycerol Stock',
  },
  CONF_SANGER_AMOUNT_TOOLTIP: {
    id: 'CONF_SANGER_AMOUNT_TOOLTIP',
    defaultMessage:
      '1 ug is provided at 20 ng/ul; all other amounts will have final concentration reported',
  },
  CONF_SANGER_TITER_TOOLTIP: {
    id: 'CONF_SANGER_TITER_TOOLTIP',
    defaultMessage:
      'This is the concentration of virus particles, measured by p24 ELISA.',
  },
  CONF_SANGER_VOLUME_TOOLTIP: {
    id: 'CONF_SANGER_VOLUME_TOOLTIP',
    defaultMessage: 'This is the total volume of virus particles chosen.',
  },
  CONF_SANGER_ALIQUOT_TOOLTIP: {
    id: 'CONF_SANGER_ALIQUOT_TOOLTIP',
    defaultMessage:
      'The number of vials and volume of each aliquot your total volume will be divided into.',
  },
  SEMICONF_ORF_SEQUENCE: {
    id: 'SEMICONF_ORF_SEQUENCE',
    defaultMessage: ' ORF Sequence',
  },
  CONF_CLOSE_BUTTON: { id: 'CONF_CLOSE_BUTTON', defaultMessage: 'Close ' },
  SEMI_CONF_COPY_TO_CLIPBOARD: {
    id: 'SEMI_CONF_COPY_TO_CLIPBOARD',
    defaultMessage: 'Copy To Clipboard',
  },
  SEMI_CONF_ORF_ERROR_POPUP_orf: {
    id: 'SEMI_CONF_ORF_ERROR_POPUP_orf',
    defaultMessage: 'Please select a clone before proceeding to next step',
  },
  SEMI_CONF_ORF_DESIGN: {
    id: 'SEMI_CONF_ORF_DESIGN',
    defaultMessage: 'Select ORF Designs',
  },
  SEMI_CONF_MATCHTYPE_INFO_MSG1_ORF: {
    id: 'SEMI_CONF_MATCHTYPE_INFO_MSG1_ORF',
    defaultMessage:
      'ORF clones are classified on stringency to the corresponding NCBI Refseq transcript.',
  },
  SEMI_CONF_MATCHTYPE_INFO_MSG2_ORF: {
    id: 'SEMI_CONF_MATCHTYPE_INFO_MSG2_ORF',
    defaultMessage:
      '{matchType}: the ORF matches 100% in both nucleotide and protein sequence.',
  },
  SEMI_CONF_MATCHTYPE_INFO_MSG3_ORF: {
    id: 'SEMI_CONF_MATCHTYPE_INFO_MSG3_ORF',
    defaultMessage:
      '{matchType}: the ORF has at least a 99% protein match (if coding) or at least a 99% nucleotide match (if non-coding).',
  },
  SEMI_CONF_MATCHTYPE_INFO_MSG4_ORF: {
    id: 'SEMI_CONF_MATCHTYPE_INFO_MSG4_ORF',
    defaultMessage:
      '{matchType}: the ORF has a good "partial" match, but may contain large contiguous indels indicating e.g. truncation or a missing/extra exon. Score is calculated using protein match (if coding) or nucleotide match (if non-coding).',
  },
  SEMI_CONF_SHRNA_TRC_CLONE_ID_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_TRC_CLONE_ID_LABEL_shrna',
    defaultMessage: 'TRC Clone ID',
  },
  SEMI_CONF_SHRNA_GENE_ID_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_GENE_ID_LABEL_shrna',
    defaultMessage: 'Gene ID',
  },
  SEMI_CONF_ORF_SEQUENCE: {
    id: 'SEMI_CONF_ORF_SEQUENCE',
    defaultMessage: 'ORF Sequence',
  },
  SEMI_CONF_TRC_VERSION_shrna: {
    id: 'SEMI_CONF_TRC_VERSION_shrna',
    defaultMessage: 'TRC Version',
  },
  SEMI_CONF_TRC_VERSION_INFO_MSG1_shrna: {
    id: 'SEMI_CONF_TRC_VERSION_INFO_MSG1_shrna',
    defaultMessage: 'TRC1 and TRC2 vectors are nearly identical,',
  },
  SEMI_CONF_TRC_VERSION_INFO_MSG2_shrna: {
    id: 'SEMI_CONF_TRC_VERSION_INFO_MSG2_shrna',
    defaultMessage:
      'with the exception of the WPRE feature found only on TRC2 clones.',
  },
  SEMI_CONF_TRC_VERSION_INFO_MSG3_shrna: {
    id: 'SEMI_CONF_TRC_VERSION_INFO_MSG3_shrna',
    defaultMessage:
      'Note that some sequences are duplicated in both TRC1 and TRC2 vectors.',
  },
  SEMI_CONF_TRC_VERSION_INFO_MSG4_shrna: {
    id: 'SEMI_CONF_TRC_VERSION_INFO_MSG4_shrna',
    defaultMessage:
      'These will have different clone ID numbers but identical sequence.',
  },
  SEMI_CONF_TRC3: { id: 'SEMI_CONF_TRC3', defaultMessage: 'TRC3' },
  SEMI_CONF_VECTOR_INFO_MSG1_ORF: {
    id: 'SEMI_CONF_VECTOR_INFO_MSG1_ORF',
    defaultMessage:
      'The {materialNumber} is a Gateway Donor vector. Each ORF donor contains spectinomycin and can be used with Gateway Destination vectors containing Kanamycin, Ampicillin etc.',
  },
  SEMI_CONF_VECTOR_INFO_MSG2_ORF: {
    id: 'SEMI_CONF_VECTOR_INFO_MSG2_ORF',
    defaultMessage:
      'The {materialNumber} are ready to use lentiviral ORF vector with puromycin selection. Each ORF clone contains a unique 24 base pair barcode for easy confirmation.',
  },
  SEMICONF_BREADCRUMB2_shrna: {
    id: 'SEMICONF_BREADCRUMB2_shrna',
    defaultMessage: 'RNAi Single Clones',
  },
  SEMICONF_SEARCH_GENESORCLONES_shrna: {
    id: 'SEMICONF_SEARCH_GENESORCLONES_shrna',
    defaultMessage: 'Search Genes/Clones',
  },
  CONF_SEARCH_MESSAGE: {
    id: 'CONF_SEARCH_MESSAGE',
    defaultMessage:
      'Search by Gene Symbol, RefSeq or Gene ID (enter up to 100 items separated by spaces)',
  },
  refseq: { id: 'refseq', defaultMessage: 'RefSeq' },
  ORDER_TEXT: { id: 'ORDER_TEXT', defaultMessage: 'Order' },
  SEMICONF_5REPORTER_sirna: {
    id: 'SEMICONF_5REPORTER_sirna',
    defaultMessage: "5' Reporter",
  },
  SEARCH_RESULTS: { id: 'SEARCH_RESULTS', defaultMessage: 'Search Results' },
  SEMICONF_SEARCH_TERMS_kicqstartProbe: {
    id: 'SEMICONF_SEARCH_TERMS_kicqstartProbe',
    defaultMessage: 'Search Terms:',
  },
  SEMICONF_SPECIES_kicqstartProbe: {
    id: 'SEMICONF_SPECIES_kicqstartProbe',
    defaultMessage: 'Species:',
  },
  SEMICONF_SEARCH_KICQSTART: {
    id: 'SEMICONF_SEARCH_KICQSTART',
    defaultMessage:
      'Search by Gene Symbol, RefSeq or Gene ID (Enter up to 25 terms separated by spaces)',
  },
  SEMICONF_UPLOAD_ERROR_MSG_sirna: {
    id: 'SEMICONF_UPLOAD_ERROR_MSG_sirna',
    defaultMessage: 'Maximum number of items per session is 25.',
  },
  CONF_SELECT_ASSAY_ERROR_MSG: {
    id: 'CONF_SELECT_ASSAY_ERROR_MSG',
    defaultMessage: 'Please select an assay before proceeding to next step',
  },
  SEMICONF_BREADCRUMB1_Kicqstart: {
    id: 'SEMICONF_BREADCRUMB1_Kicqstart',
    defaultMessage: 'Custom Products',
  },
  SEMICONF_BREADCRUMB2_Kicqstart: {
    id: 'SEMICONF_BREADCRUMB2_Kicqstart',
    defaultMessage: 'Oligos & Probes',
  },
  CONF_LABEL_HEADER_KicqStart: {
    id: 'CONF_LABEL_HEADER_KicqStart',
    defaultMessage: 'KiCqStart',
  },
  CONF_LABEL_HEADER_PROBE_ASSAYS_KicqStart: {
    id: 'CONF_LABEL_HEADER_PROBE_ASSAYS_KicqStart',
    defaultMessage: ' Probe Assays',
  },
  SEMICONF_SELECT_ASSAYS_Kicqstart: {
    id: 'SEMICONF_SELECT_ASSAYS_Kicqstart',
    defaultMessage: 'Select Assays',
  },
  SEMI_CONF_ENSEMBL_DENE_SYM_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_ENSEMBL_DENE_SYM_ID_LABEL_sangerCrispr',
    defaultMessage: 'Ensembl Gene Symbol',
  },
  SEMI_CONF_NCBIGENESYMBOL_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_NCBIGENESYMBOL_ID_LABEL_sangerCrispr',
    defaultMessage: 'NCBI Gene Symbol',
  },
  SEMI_CONF_NCBIGENEID_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_NCBIGENEID_ID_LABEL_sangerCrispr',
    defaultMessage: 'NCBI Gene ID',
  },
  SEMI_CONF_SPECIES__ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_SPECIES__ID_LABEL_sangerCrispr',
    defaultMessage: 'Species',
  },
  CONF_SANGERVECTOR_RESULT_sangercrisprclones: {
    id: 'CONF_SANGERVECTOR_RESULT_sangercrisprclones',
    defaultMessage: 'Sanger Vector',
  },
  CONF_SANGER_ERROR_POPUP_sangercrispr: {
    id: 'CONF_SANGER_ERROR_POPUP_sangercrispr',
    defaultMessage: 'Please select a gRNA before proceeding to next step',
  },
  CONF_Crispr_Search_Criteria_sangercrisprclones: {
    id: 'CONF_Crispr_Search_Criteria_sangercrisprclones',
    defaultMessage: 'Search Criteria',
  },
  SEMI_CONF_SANGER_CRIPSR_selectsangerclones: {
    id: 'SEMI_CONF_SANGER_CRIPSR_selectsangerclones',
    defaultMessage: 'Select Sanger Clones',
  },
  CONF_SELECT_CLONES_FILTER_RESULTS_HELP_TEXT_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_FILTER_RESULTS_HELP_TEXT_sangerCrispr',
    defaultMessage: 'Check the box next to the species you’d like to target',
  },
  SEMI_CONF_SANGER_CLONE_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_SANGER_CLONE_ID_LABEL_sangerCrispr',
    defaultMessage: 'Sanger Clone ID',
  },
  SEMI_CONF_DNA_TARGET_SEQ_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_DNA_TARGET_SEQ_ID_LABEL_sangerCrispr',
    defaultMessage: 'DNA Target Sequence',
  },
  SEMI_CONF_MORE_INFO_ID_LABEL_sangerCrispr: {
    id: 'SEMI_CONF_MORE_INFO_ID_LABEL_sangerCrispr',
    defaultMessage: 'More Info',
  },
  CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_sangerCrispr',
    defaultMessage: 'View vector map and features at',
  },
  CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_LINK_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_LINK_sangerCrispr',
    defaultMessage: 'CRISPR Clone, Control, and Cas9 Essentials.',
  },
  SEMI_CONF_SANGER_CRISPR_CLONES_HEADER_sangerCrispr: {
    id: 'SEMI_CONF_SANGER_CRISPR_CLONES_HEADER_sangerCrispr',
    defaultMessage: 'Sanger CRISPR Clones',
  },
  CONF_REVIEW_ORDER_sangerCrispr: {
    id: 'CONF_REVIEW_ORDER_sangerCrispr',
    defaultMessage: 'Review & Confirm',
  },
  CONF_SEARCH_MESSAGE_CRISPR: {
    id: 'CONF_SEARCH_MESSAGE_CRISPR',
    defaultMessage:
      'Search by Gene Symbol, Clone ID or Gene ID (enter up to 100 items separated by spaces)',
  },
  SEMICONF_TARGET_SEQUENCE_shrna: {
    id: 'SEMICONF_TARGET_SEQUENCE_shrna',
    defaultMessage: 'Target Sequence',
  },
  SEMICONF_GENE_SYN_shrna: {
    id: 'SEMICONF_GENE_SYN_shrna',
    defaultMessage: 'Gene Synonym',
  },
  GENE_SYMBOL: { id: 'GENE_SYMBOL', defaultMessage: 'Gene Symbol' },
  SEMI_CONF_SHRNA_REF_SEQ_ID_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_REF_SEQ_ID_LABEL_shrna',
    defaultMessage: 'Ref Seq',
  },
  SEMI_CONF_SHRNA_SPECIES_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_SPECIES_LABEL_shrna',
    defaultMessage: 'Species',
  },
  SEMI_CONF_SHRNA_REGION_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_REGION_LABEL_shrna',
    defaultMessage: 'Region',
  },
  SEMI_CONF_VERSION_shrna: {
    id: 'SEMI_CONF_VERSION_shrna',
    defaultMessage: 'Version',
  },
  SEMI_CONF_METHOD_shrna: {
    id: 'SEMI_CONF_METHOD_shrna',
    defaultMessage: 'Method',
  },
  SEMI_CONF_CELL_TYPE_shrna: {
    id: 'SEMI_CONF_CELL_TYPE_shrna',
    defaultMessage: 'Cell Type',
  },
  SEMI_CONF_KNOCKDOWN_shrna: {
    id: 'SEMI_CONF_KNOCKDOWN_shrna',
    defaultMessage: 'Knockdown',
  },
  CONF_CONFIRM_ORDER: {
    id: 'CONF_CONFIRM_ORDER',
    defaultMessage: 'Review & Confirm',
  },
  SEMI_CONF_SHIPPING_HOURS: {
    id: 'SEMI_CONF_SHIPPING_HOURS',
    defaultMessage:
      'Usually ships in 48 hours. (Orders outside of US, please allow an additional 1-2 weeks for delivery)',
  },
  SEMI_CONF_SHIPPING_HOURS_DNA: {
    id: 'SEMI_CONF_SHIPPING_HOURS_DNA',
    defaultMessage:
      'Usually ships in 2 - 3 weeks. (Orders outside of the US, please allow additional 1-2 weeks for delivery)',
  },
  SEMI_CONF_SHIPPING_HOURS_VIRUS: {
    id: 'SEMI_CONF_SHIPPING_HOURS_VIRUS',
    defaultMessage:
      'Usually ships in 4 - 5 weeks. (Orders outside of the US, please allow additional 1-2 weeks for delivery)',
  },
  SEMI_CONF_SHRNA_VALIDATION_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_VALIDATION_LABEL_shrna',
    defaultMessage: 'Validation',
  },
  SEMI_CONF_SHRNA_GENE_SYMBOL_LABEL_shrna: {
    id: 'SEMI_CONF_SHRNA_GENESYMBOL_LABEL_shrna',
    defaultMessage: 'Gene Symbol',
  },
  SEMICONF_VALIDATED_LABEL_shrna: {
    id: 'SEMICONF_VALIDATED_LABEL_shrna',
    defaultMessage: 'Validated',
  },
  SEMICONF_SHRNA_ERROR_POPUP_shrna: {
    id: 'SEMICONF_SHRNA_ERROR_POPUP_shrna',
    defaultMessage: 'Please select a shRNA before proceeding to next step',
  },
  SEMI_CONF_SHRNA_SEARCH_QUERY_CRITERIA_shrna: {
    id: 'SEMI_CONF_SHRNA_SEARCH_QUERY_CRITERIA_shrna',
    defaultMessage: 'Search Query & Criteria',
  },
  SEMI_CONF_SHRNA_selectShrnaclones: {
    id: 'SEMI_CONF_SHRNA_selectShrnaclones',
    defaultMessage: 'Select shRNA Clones',
  },
  SEMI_CONF_TRC1: { id: 'SEMI_CONF_TRC1', defaultMessage: 'TRC1' },
  SEMI_CONF_TRC2: { id: 'SEMI_CONF_TRC2', defaultMessage: 'TRC2' },
  YES: { id: 'YES', defaultMessage: 'Yes' },
  NO: { id: 'NO', defaultMessage: 'No' },
  SEMICONF_BREADCRUMB1_shrna: {
    id: 'SEMICONF_BREADCRUMB1_shrna',
    defaultMessage: 'Custom Products',
  },
  CONTACT_CUSTOMER_SERVICE: {
    id: 'CONTACT_CUSTOMER_SERVICE',
    defaultMessage: 'contact customer service',
  },
  REQUEST_QUOTATION_TEXT: {
    id: 'REQUEST_QUOTATION_TEXT',
    defaultMessage:
      'Online ordering is currently unavailable for China.  Please contact Customer Service (siRNAorder@merckgroup.com) with your contact information and the SASI ID number of interest.  You can email the summary on this screen with email text or excel to the email provided.',
  },
  CONF_PURIFICATION_DNA_PLATES: {
    id: 'CONF_PURIFICATION_DNA_PLATES',
    defaultMessage: 'Purification:',
  },
  SEMICONF_CONFIRM_ORDER_SIZE_sirna: {
    id: 'SEMICONF_CONFIRM_ORDER_SIZE_sirna',
    defaultMessage: 'Size:',
  },
  SEMICONF_CONFIRM_ORDER_SEQ_START_sirna: {
    id: 'SEMICONF_CONFIRM_ORDER_SEQ_START_sirna',
    defaultMessage: 'Sequence Start:',
  },
  REQUEST_QUOTATION: {
    id: 'REQUEST_QUOTATION',
    defaultMessage: 'Request Quotation',
  },
  SEMICONF_BREADCRUMB2_sirna: {
    id: 'SEMICONF_BREADCRUMB2_sirna',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CONF_LABEL_HEADER_sirna: {
    id: 'CONF_LABEL_HEADER_sirna',
    defaultMessage: 'Predesigned siRNA',
  },
  SEMICONF_SELECT_ASSAYS_sirna: {
    id: 'SEMICONF_SELECT_ASSAYS_sirna',
    defaultMessage: 'Select Assays',
  },
  SEMICONF_CONFIRM_ORDER_sirna: {
    id: 'SEMICONF_CONFIRM_ORDER_sirna',
    defaultMessage: 'Review & Confirm',
  },
  SEMICONF_INFO_TEXT_sirna: {
    id: 'SEMICONF_INFO_TEXT_sirna',
    defaultMessage: 'All predesigned siRNA carry the ',
  },
  SEMICONF_SIGAM_ALDRICH_INFO_TEXT_sirna: {
    id: 'SEMICONF_SIGAM_ALDRICH_INFO_TEXT_sirna',
    defaultMessage: 'Sigma-Aldrich guarantee',
  },
  SEMICONF_NOTE_INFO_TEXT_sirna: {
    id: 'SEMICONF_NOTE_INFO_TEXT_sirna',
    defaultMessage:
      'siRNAs are listed in descending order of expected efficacy as predicted by the Rosetta algorithm.',
  },
  SEMICONF_VALIDATED_OR_POSITIVE_LABEL_sirna: {
    id: 'SEMICONF_VALIDATED_OR_POSITIVE_LABEL_sirna',
    defaultMessage: '{sirnaType}',
  },
  SEMICONF_HELP_ICON_BOLDTEXT_SEQUENCE_START_sirna: {
    id: 'SEMICONF_HELP_ICON_BOLDTEXT_SEQUENCE_START_sirna',
    defaultMessage: 'Approx. siRNA Start',
  },
  SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_sirna',
    defaultMessage:
      ' gives the approximate nucleotide positioning of\n       where the MISSION',
  },
  SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_SYMBOL_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_SYMBOL_sirna',
    defaultMessage: 'Ã,Â®',
  },
  SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_2_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_2_sirna',
    defaultMessage:
      ' siRNA targets in the gene of interest. The\n       displayed nucleotide position is relative to the beginning of the Req Seq\n        sequence. For example, a Targeted Gene Region of 1597 means that the MISSION',
  },
  SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_3_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SEQUENCE_START_3_sirna',
    defaultMessage:
      ' siRNA targets the region approximately 1597 nucleotides\n         downstream from the beginning of the Ref Seq sequence.',
  },
  SEMICONF_HELP_ICON_TEXT_SIZE_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SIZE_sirna',
    defaultMessage: '1 OD equates to roughly 5 nmol',
  },
  SEMICONF_HELP_ICON_BOLDTEXT_SIRNATYPE_MISSION_sirna: {
    id: 'SEMICONF_HELP_ICON_BOLDTEXT_SIRNATYPE_MISSION_sirna',
    defaultMessage: 'Validated MISSION',
  },
  SEMICONF_HELP_ICON_BOLDTEXT_SIRNATYPE_2_sirna: {
    id: 'SEMICONF_HELP_ICON_BOLDTEXT_SIRNATYPE_2_sirna',
    defaultMessage: ' siRNAs',
  },
  SEMICONF_HELP_ICON_TEXT_SIRNATYPE_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SIRNATYPE_sirna',
    defaultMessage:
      ' have been functionally validated in\n       Hela cells by Sigma scientists to Knockdown gene expression by 75% or\n       greater. With Validated Mission',
  },
  SEMICONF_HELP_ICON_TEXT_SIRNATYPE_2_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SIRNATYPE_2_sirna',
    defaultMessage:
      ' siRNAs, we have done the upfront\n       validation work, so that you do not have to.',
  },
  CONF_DISCOUNT_MESSAGE: {
    id: 'CONF_DISCOUNT_MESSAGE',
    defaultMessage:
      'Don’t miss out on the substantial discount you receive when you order 5 or more clones of any gene in the same format; additional discounts are given for > 25 quantities',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_CLEAR_WELL: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_CLEAR_WELL',
    defaultMessage: 'CLEAR WELL',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_CLEAR_WELL_DESCRIPTION: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_CLEAR_WELL_DESCRIPTION',
    defaultMessage: 'Are you sure you want to clear the well?',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_DELETE_PLATE: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_DELETE_PLATE',
    defaultMessage: 'DELETE PLATE',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_DELETE_PLATE_DESCRIPTION: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_DELETE_PLATE_DESCRIPTION',
    defaultMessage: 'Are you sure you want to delete the plate?',
  },
  SEMICONF_KICQSTART_GENE_ARRAY_CONFIRM: {
    id: 'SEMICONF_KICQSTART_GENE_ARRAY_CONFIRM',
    defaultMessage: 'Confirm',
  },
  SEMICONF_SUBTOTAL_KICQSTART: {
    id: 'SEMICONF_SUBTOTAL_KICQSTART',
    defaultMessage: 'Subtotals',
  },
  SEMICONF_OLIGOS_SELECTED_KICQSTART: {
    id: 'SEMICONF_OLIGOS_SELECTED_KICQSTART',
    defaultMessage: 'Oligos Selected: ',
  },
  CUSTOM_CRISPR_SOLUTIONS: {
    id: 'CUSTOM_CRISPR_SOLUTIONS',
    defaultMessage: 'Custom CRISPR Solutions',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_ONE_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_ONE_crisprgrna',
    defaultMessage: 'Contact',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_TWO_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_TWO_crisprgrna',
    defaultMessage: 'for other customization choices, including',
  },
  CUSTOM_CRISPR_RECOMMENDATIONS: {
    id: 'CUSTOM_CRISPR_RECOMMENDATIONS',
    defaultMessage: 'Recommendations based on application',
  },
  CUSTOM_CRISPR_CRRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_CRRNA_POPUP_customcrispr',
    defaultMessage: 'crRNA',
  },
  CUSTOM_CRISPR_SGRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_SGRNA_POPUP_customcrispr',
    defaultMessage: 'sgRNA',
  },
  CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr',
    defaultMessage: 'Modified sgRNA',
  },
  CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr',
    defaultMessage: 'Modified crRNA',
  },
  SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_crisprgrna: {
    id: 'SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_crisprgrna',
    defaultMessage:
      'We are so confident in the performance of our SygRNA® products, that we fully guarantee the quality and performance of any guide we produce, including custom sequences. If your synthetic guides do not yield detectable cleavage at the intended target site, we will provide a one-time replacement, free of charge.',
  },
  SEMICONF_PERFORMANCE_GUARANTEE_POPUP_SECONDHALF_crisprgrna: {
    id: 'SEMICONF_PERFORMANCE_GUARANTEE_POPUP_SECONDHALF_crisprgrna',
    defaultMessage:
      'To qualify for this guarantee, simply send an image or sequencing data from a single experiment demonstrating detectable cleavage using one of our positive controls, side-by-side with the negative results from your SygRNA® guide. To receive your replacement, simply email',
  },
  SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_AFTEREMAIL_crisprgrna: {
    id: 'SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_AFTEREMAIL_crisprgrna',
    defaultMessage:
      'and include sample data from a representative experiment (T7E1, TIDE, or NGS).',
  },
  SEMICONF_PERFORMANCE_GUARANTEE_POPUP_TEXT_crisprgrna: {
    id: 'SEMICONF_PERFORMANCE_GUARANTEE_POPUP_TEXT_crisprgrna',
    defaultMessage: 'View Our Performance Guarantee',
  },
  CONF_MANUAL_SEARCH_crisprgrna: {
    id: 'CONF_MANUAL_SEARCH_crisprgrna',
    defaultMessage: 'Manual Search',
  },
  CONF_UPLOAD_QUERIES_crisprgrna: {
    id: 'CONF_UPLOAD_QUERIES_crisprgrna',
    defaultMessage: 'Upload Queries',
  },
  HIDE: { id: 'HIDE', defaultMessage: 'Hide' },
  EXPAND: { id: 'EXPAND', defaultMessage: 'Expand' },
  SEMI_CONF_DETAILS_crispgrna: {
    id: 'SEMI_CONF_DETAILS_crispgrna',
    defaultMessage: 'Details',
  },
  CONF_CAUTION_HEADING: {
    id: 'CONF_CAUTION_HEADING',
    defaultMessage: 'Caution',
  },
  CONF_CAUTION_POPUP_TEXT_TUBES: {
    id: 'CONF_CAUTION_POPUP_TEXT_TUBES',
    defaultMessage:
      'Adding a new set of items will override any existing items in this session.',
  },
  CONF_CONTINUE_DNA_PLATES: {
    id: 'CONF_CONTINUE_DNA_PLATES',
    defaultMessage: 'Continue',
  },
  CONF_DROP_XLS_OR_XLSX_FILE_OR: {
    id: 'CONF_DROP_XLS_OR_XLSX_FILE_OR',
    defaultMessage: 'Drop XLS or XLSX files ',
  },
  OR: { id: 'OR', defaultMessage: 'or' },
  BROWSE: { id: 'BROWSE', defaultMessage: 'Browse' },
  CONF_DELETE_ALL_ITEM_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_ITEM_DNA_PLATES',
    defaultMessage: 'Delete All',
  },
  CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES',
    defaultMessage:
      'Are you sure you want to remove ALL items from your order?',
  },
  CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES',
    defaultMessage: 'Delete All',
  },
  CONF_DELETE_ITEM_DNA_PLATES: {
    id: 'CONF_DELETE_ITEM_DNA_PLATES',
    defaultMessage: 'Delete  Item Confirmation',
  },
  CONF_DELETE_ITEM_MSG_DNA_PLATES: {
    id: 'CONF_DELETE_ITEM_MSG_DNA_PLATES',
    defaultMessage:
      'Are you sure you want to remove the selected item from your order?',
  },
  CONF_DELETE_BUTTON_TEXT_DNA_PLATES: {
    id: 'CONF_DELETE_BUTTON_TEXT_DNA_PLATES',
    defaultMessage: 'Delete',
  },
  SEMI_CONF_SPECIFICATION_STRUCTURE_sgRNA_crisprgrna: {
    id: 'SEMI_CONF_SPECIFICATION_STRUCTURE_sgRNA_crisprgrna',
    defaultMessage: 'sgRNA (crRNA +tracrRNA as one)',
  },
  SEMI_CONF_SPECIFICATION_SYNTHESIS_SCALE_3nmol_crisprgrna: {
    id: 'SEMI_CONF_SPECIFICATION_SYNTHESIS_SCALE_3nmol_crisprgrna',
    defaultMessage: '3 nmol',
  },
  SEMI_CONF_SPEC_AMOUNT_sangercrisprclones_PC_SPEC_1UG: {
    id: '_PC_SPEC_1UG',
    defaultMessage: '1 µg',
  },
  SEMI_CONF_SPEC_AMOUNT_sangercrisprclones_PC_SPEC_10UG: {
    id: '_PC_SPEC_10UG',
    defaultMessage: '10 µg',
  },
  SEMI_CONF_SPEC_AMOUNT_sangercrisprclones_PC_SPEC_25UG: {
    id: '_PC_SPEC_25UG',
    defaultMessage: '25 µg',
  },
  SEMI_CONF_SPEC_AMOUNT_sangercrisprclones_PC_SPEC_100UG: {
    id: '_PC_SPEC_100UG',
    defaultMessage: '100 µg',
  },
  SEMI_CONF_VECTOR_shrna: {
    id: 'SEMI_CONF_VECTOR_shrna',
    defaultMessage: 'pLKO-puro',
  },
  SEMICONF_SEARCH_KICQSTART_NOTE: {
    id: 'SEMICONF_SEARCH_KICQSTART_NOTE',
    defaultMessage: 'Note: ',
  },
  SEMICONF_SEARCH_KICQSTART_NOTE_TEXT: {
    id: 'SEMICONF_SEARCH_KICQSTART_NOTE_TEXT',
    defaultMessage:
      'Due to high interest, we provided a quick search for KiCqStart Probe Assays to order a',
  },
  SEMICONF_SEARCH_KICQSTART_NOTE_TEXT_LINK: {
    id: 'SEMICONF_SEARCH_KICQSTART_NOTE_TEXT_LINK',
    defaultMessage: 'SARS positive control Dual-Labeled Probe Assay',
  },
  SEMICONF_SHOWING_RESULT_KICQSTART: {
    id: 'SEMICONF_SHOWING_RESULT_KICQSTART',
    defaultMessage: 'Showing 1-10 of 18 Results',
  },
  SEMICONF_AMBIENT_ROOM_TEMPERATURE_crisprgrna: {
    id: 'SEMICONF_AMBIENT_ROOM_TEMPERATURE_crisprgrna',
    defaultMessage: 'Ambient (Room Temperature)',
  },
  SEMICONF_UPLOAD_ERROR_MSG_kicqstartPrimers: {
    id: 'SEMICONF_UPLOAD_ERROR_MSG_kicqstartPrimers',
    defaultMessage: 'Maximum number of items per session is 10.',
  },
  SEMI_CONF_SINGLE_UNIT_COST_shrna: {
    id: 'SEMI_CONF_SINGLE_UNIT_COST_shrna',
    defaultMessage: 'Single Unit Cost',
  },
  SEMI_CONF_BULK_COST_shrna: {
    id: 'SEMI_CONF_BULK_COST_shrna',
    defaultMessage: 'Bulk Cost',
  },
  SEMI_CONF_FIVE_OR_MORE_shrna: {
    id: 'SEMI_CONF_FIVE_OR_MORE_shrna',
    defaultMessage: 'for five or more',
  },
  SEMI_CONF_PER_UNIT_shrna: {
    id: 'SEMI_CONF_PER_UNIT_shrna',
    defaultMessage: 'Per Unit',
  },
  SEMICONF_BREADCRUMB3_Kicqstart: {
    id: 'SEMICONF_BREADCRUMB3_Kicqstart',
    defaultMessage: 'Breadcrumb 3',
  },
  SEMICONF_5REPORTER_Kicqstart: {
    id: 'SEMICONF_5REPORTER_Kicqstart',
    defaultMessage: "5' Reporter™",
  },
  SEMICONF_SUBTOTAL_sirna: {
    id: 'SEMICONF_SUBTOTAL_sirna',
    defaultMessage: 'Subtotals',
  },
  SEMICONF_OLIGOS_SELECTED_sirna: {
    id: 'SEMICONF_OLIGOS_SELECTED_sirna',
    defaultMessage: 'Oligos Selected: ',
  },
  SEMICONF_SEARCH_sirna: {
    id: 'SEMICONF_SEARCH_sirna',
    defaultMessage:
      'Search by Gene Symbol, RefSeq or Gene ID (Enter up to 25 terms separated by spaces)',
  },
  SEMICONF_SIRNA_TYPE_sirna: {
    id: 'SEMICONF_SIRNA_TYPE_sirna',
    defaultMessage: 'siRNA Type',
  },
  SEMICONF_PRODUCT_sirna: {
    id: 'SEMICONF_PRODUCT_sirna',
    defaultMessage: 'Product #',
  },
  SEMICONF_HELP_ICON_TEXT_SIRNATYPE_MISSION_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SIRNATYPE_MISSION_sirna',
    defaultMessage:
      ' have been functionally validated in\n       Hela cells by Sigma scientists to Knockdown gene expression by 75% or\n       greater. With Validated MISSION',
  },
  SEMICONF_SIRNA_ROUTE_TITLE_NAME_sirna: {
    id: 'SEMICONF_SIRNA_ROUTE_TITLE_NAME_sirna',
    defaultMessage: 'SiRNA',
  },
  SEMICONF_AMOUNT_TOOLTIP_shrna: {
    id: 'SEMICONF_AMOUNT_TOOLTIP_shrna',
    defaultMessage:
      '1 ug is provided at 20 ng/ul; all other amounts will have final concentration reported',
  },
  SEMI_CONF_CHOOSE_FORMAT: {
    id: 'SEMI_CONF_CHOOSE_FORMAT',
    defaultMessage: 'Choose Physical Format',
  },
  SEMI_CONF_ORDER_MORE_CLONES: {
    id: 'SEMI_CONF_ORDER_MORE_CLONES',
    defaultMessage: 'Order More Clones',
  },
  SEMI_CONF_NEW_PRODUCTS_AND_CONTROLS: {
    id: 'SEMI_CONF_NEW_PRODUCTS_AND_CONTROLS',
    defaultMessage: 'New Products and Controls',
  },
  SEMICONF_HELP_ICON_BOLDTEXT_MISSION_sirna: {
    id: 'SEMICONF_HELP_ICON_BOLDTEXT_MISSION_sirna',
    defaultMessage: 'MISSION',
  },
  SEMICONF_HELP_ICON_TEXT_SIRNATYPE_INFORMATION_sirna: {
    id: 'SEMICONF_HELP_ICON_TEXT_SIRNATYPE_INFORMATION_sirna',
    defaultMessage:
      ' have been designed using a world-class siRNA design algorithm licensed from Rosetta\n    Inpharmatics, a leader in advanced siRNA research. The Rosetta-powered siRNA design algorithm has been\n    optimized with over 3 years of continuous development for enhanced performance in RNAi applications.\n    New and critical siRNA design rules incorporated into the latest algorithm lead to increased target specificity\n     and knockdown for low abundance messages.',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT1_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT1_crisprgrna',
    defaultMessage:
      'All targets must have a minimum of 1bp mismatch to the rest of the genome',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT2_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT2_crisprgrna',
    defaultMessage:
      "All targets must be within the first 2/3 of the coding region, and exclude the first 90 bp 3' of ATG start codon",
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT3_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT3_crisprgrna',
    defaultMessage: 'gRNAs with 5 or more consecutive T bases are eliminated',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT4_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT4_crisprgrna',
    defaultMessage: 'No overlapping gRNAs',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT5_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT5_crisprgrna',
    defaultMessage:
      'Where possible all targets must be in exons conserved across all NM and XM transcripts',
  },
  SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT6_crisprgrna: {
    id: 'SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT6_crisprgrna',
    defaultMessage:
      '"Top Choice" guides target the maximum number of transcripts and have the highest efficiency and specificity scores',
  },
  SEMICONF_PERFORMANCE_GUARANTEE_CONTENT_EMAIL_crisprgrna: {
    id: 'SEMICONF_PERFORMANCE_GUARANTEE_CONTENT_EMAIL_crisprgrna',
    defaultMessage: 'oligotechserv@merckgroup.com',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_1_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_ONE_crisprgrna',
    defaultMessage: 'RNA for nucleases other than SpCas9 or FnCas9',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_2_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_TWO_crisprgrna',
    defaultMessage: 'Larger quantities',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_3_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_THREE_crisprgrna',
    defaultMessage: 'Panels for gene families',
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_4_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_FOUR_crisprgrna',
    defaultMessage:
      "Modifications other than our standard 2'-O-methyl and phosphorothioate",
  },
  SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_5_crisprgrna: {
    id: 'SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_FIVE_crisprgrna',
    defaultMessage: 'All other inquiries ',
  },
  SEMICONF_PRIMERS_kicqstartPrimers: {
    id: 'SEMICONF_PRIMERS_kicqstartPrimers',
    defaultMessage: ' Primers',
  },
  SEMICONF_CHECKBOX_LABEL_kicqstartPrimers: {
    id: 'SEMICONF_CHECKBOX_LABEL_kicqstartPrimers',
    defaultMessage: 'SARS-CoV-2 ',
  },
  SEMICONF_CHECKBOX_LABEL_LINK_kicqstartPrimers: {
    id: 'SEMICONF_CHECKBOX_LABEL_LINK_kicqstartPrimers',
    defaultMessage:
      'Order a SARS-CoV-2 positive control Dual-Labeled Probe assay',
  },
  SEMICONF_CAUTION_POPUP_TEXT1: {
    id: 'SEMICONF_CAUTION_POPUP_TEXT1',
    defaultMessage: 'Are you sure you want to change the {type}?',
  },
  SEMICONF_CAUTION_POPUP_TEXT2: {
    id: 'SEMICONF_CAUTION_POPUP_TEXT2',
    defaultMessage: 'Any custom changes you have made will be lost.',
  },
  _PC_SH_MAIN_HEADER_milliplex: {
    id: '_PC_SH_MAIN_HEADER_milliplex',
    defaultMessage: 'Multiplex Assays Using Luminex',
  },
  _PC_SPEC_5MOD_standard: {
    id: '_PC_SPEC_5MOD_standard',
    defaultMessage: "Optional 5' & 3' Modifications ",
  },
  _PC_SPEC_5MOD_iscaledna: {
    id: '_PC_SPEC_5MOD_iscaledna',
    defaultMessage: "Optional 5' & 3' Modifications ",
  },
  _PC_SPEC_internalModS: {
    id: '_PC_SPEC_internalModS',
    defaultMessage: 'Optional Internal Modifications ',
  },
  _PC_SPEC_MODIFIED_BASES: {
    id: '_PC_SPEC_MODIFIED_BASES',
    defaultMessage: 'Optional Bases',
  },
  _PC_SPEC_0_025UM: { id: '_PC_SPEC_0_025UM', defaultMessage: '0.025 µmole' },
  _PC_SPEC_0_2UM: { id: '_PC_SPEC_0_2UM', defaultMessage: '0.2 µmole' },
  _PC_SPEC_0_05UM: { id: '_PC_SPEC_0_05UM', defaultMessage: '0.05 µmole' },
  _PC_SPEC_1_0UM: { id: '_PC_SPEC_1_0UM', defaultMessage: '1 µmole' },
  _PC_SPEC_10_0UM: { id: '_PC_SPEC_10_0UM', defaultMessage: '10 µmole' },
  _PC_SPEC_15_0UM: { id: '_PC_SPEC_15_0UM', defaultMessage: '15 µmole' },
  _PC_SPEC_0_1UM: { id: '_PC_SPEC_0_1UM', defaultMessage: '0.1 µmole' },
  _PC_SPEC_0_15UM: { id: '_PC_SPEC_0_15UM', defaultMessage: '0.15 µmole' },
  _PC_SPEC_Unpurified: {
    id: '_PC_SPEC_Unpurified',
    defaultMessage: 'Unpurified',
  },
  _PC_SPEC_Desalt: { id: '_PC_SPEC_Desalt', defaultMessage: 'Desalt' },
  _PC_SPEC_PAGE: { id: '_PC_SPEC_PAGE', defaultMessage: 'PAGE' },
  _PC_SPEC_CARTRIDGE: { id: '_PC_SPEC_CARTRIDGE', defaultMessage: 'Cartridge' },
  _PC_SPEC_CONCENTRATION: {
    id: '_PC_SPEC_CONCENTRATION',
    defaultMessage: 'Concentration',
  },
  _PC_SPEC_0UM: { id: '_PC_SPEC_0UM', defaultMessage: '0 µM' },
  _PC_SPEC_20UM: { id: '_PC_SPEC_20UM', defaultMessage: '20 µM' },
  _PC_SPEC_50UM: { id: '_PC_SPEC_50UM', defaultMessage: '50 µM' },
  _PC_SPEC_100UM: { id: '_PC_SPEC_100UM', defaultMessage: '100 µM' },
  _PC_SPEC_200UM: { id: '_PC_SPEC_200UM', defaultMessage: '200 µM' },
  _PC_SPEC_500UM: { id: '_PC_SPEC_500UM', defaultMessage: '500 µM' },
  _PC_SPEC_OTHER: { id: '_PC_SPEC_OTHER', defaultMessage: 'Other' },
  _PC_SPEC_SYNTHESIS_SCALE: {
    id: '_PC_SPEC_SYNTHESIS_SCALE',
    defaultMessage: 'Synthesis Scale',
  },
  _PC_SPEC_PURICIFATION: {
    id: '_PC_SPEC_PURICIFATION',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_NOFT: {
    id: '_PC_SPEC_NOFT',
    defaultMessage: 'Number of Tubes per Oligo',
  },
  _PC_SPEC_DESALT: { id: '_PC_SPEC_DESALT', defaultMessage: 'Desalt' },
  _PC_GHT_OLIGO_SPEC: {
    id: '_PC_GHT_OLIGO_SPEC',
    defaultMessage: 'Specifications',
  },
  _PC_SPEC_OLIGO_FORMAT: {
    id: '_PC_SPEC_OLIGO_FORMAT',
    defaultMessage: 'Format',
  },
  _PC_SPEC_SHIPPING: {
    id: '_PC_SPEC_SHIPPING',
    defaultMessage: 'Shipping Options',
  },
  _PC_SPEC_HPLC: { id: '_PC_SPEC_HPLC', defaultMessage: 'HPLC' },
  _PC_SPEC_PUREDIT: { id: '_PC_SPEC_PUREDIT', defaultMessage: 'PURedit™' },
  _PC_SPEC_STANDARD: { id: '_PC_SPEC_STANDARD', defaultMessage: 'Standard' },
  _PC_SPEC_VIVO: { id: '_PC_SPEC_VIVO', defaultMessage: 'In Vivo Treatment' },
  _PC_SPEC_DRY: { id: '_PC_SPEC_DRY', defaultMessage: 'Dry' },
  _PC_SPEC_AMBIENT: { id: '_PC_SPEC_AMBIENT', defaultMessage: 'Ambient ' },
  _PC_SPEC_IS_WATER: {
    id: '_PC_SPEC_IS_WATER',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_SPEC_IS_TE: { id: '_PC_SPEC_IS_TE', defaultMessage: 'In Solution (TE)' },
  _PC_SPEC_IS_TRIS: {
    id: '_PC_SPEC_IS_TRIS',
    defaultMessage: 'In Solution (TRIS)',
  },
  _PC_SPEC_RP1: { id: '_PC_SPEC_RP1', defaultMessage: 'Cartridge' },
  _PC_SECONDARY_PATTERN_NONE: {
    id: '_PC_SECONDARY_PATTERN_NONE',
    defaultMessage: 'None',
  },
  _PC_SPEC_NONE: { id: '_PC_SPEC_NONE', defaultMessage: 'None' },
  _PC_SPEC_Amino_Modifier_C3_TFA: {
    id: '_PC_SPEC_Amino_Modifier_C3_TFA',
    defaultMessage: 'Amino-Modifier C3',
  },
  _PC_SPEC_3_Amino_Modifier_C7: {
    id: '_PC_SPEC_3_Amino_Modifier_C7',
    defaultMessage: 'Amino-Modifier C7',
  },
  _PC_SPEC_3_Biotin_TEG: {
    id: '_PC_SPEC_3_Biotin_TEG',
    defaultMessage: 'Biotin TEG',
  },
  _PC_SPEC_Phosphate: { id: '_PC_SPEC_Phosphate', defaultMessage: 'Phosphate' },
  _PC_SPEC_Amino_Modifier_C12: {
    id: '_PC_SPEC_Amino_Modifier_C12',
    defaultMessage: 'Amino-Modifier C12',
  },
  _PC_SPEC_Amino_Modifier_C6: {
    id: '_PC_SPEC_Amino_Modifier_C6',
    defaultMessage: 'Amino-Modifier C6',
  },
  _PC_SPEC_BIOTIN: { id: '_PC_SPEC_BIOTIN', defaultMessage: 'Biotin' },
  _PC_SPEC_BIOTIN_TEG: {
    id: '_PC_SPEC_BIOTIN_TEG',
    defaultMessage: 'Biotin TEG',
  },
  _PC_SPEC_HEX: { id: '_PC_SPEC_HEX', defaultMessage: 'HEX' },
  _PC_SPEC_TET: { id: '_PC_SPEC_TET', defaultMessage: 'TET' },
  _PC_SPEC_6_FAM: {
    id: '_PC_SPEC_6_FAM',
    defaultMessage: '6-FAM (fluorescein)',
  },
  _PC_SECONDARY_PATTERN_MODERATE: {
    id: '_PC_SECONDARY_PATTERN_MODERATE',
    defaultMessage: 'Moderate',
  },
  _PC_SEQUENCE_PREVIEW: {
    id: '_PC_SEQUENCE_PREVIEW',
    defaultMessage: 'Sequence Preview',
  },
  _PC_SECONDARY_PATTERN_VERY_WEAK: {
    id: '_PC_SECONDARY_PATTERN_VERY_WEAK',
    defaultMessage: 'Very Weak',
  },
  _PC_SECONDARY_PATTERN_VERY_STRONG: {
    id: '_PC_SECONDARY_PATTERN_VERY_STRONG',
    defaultMessage: 'Very Strong',
  },
  _PC_SECONDARY_PATTERN_WEAK: {
    id: '_PC_SECONDARY_PATTERN_WEAK',
    defaultMessage: 'Weak',
  },
  _PC_SECONDARY_PATTERN_STRONG: {
    id: '_PC_SECONDARY_PATTERN_STRONG',
    defaultMessage: 'Strong',
  },
  _PC_PLATE_SPECIFICATIONS_AMBIENT: {
    id: '_PC_PLATE_SPECIFICATIONS_AMBIENT',
    defaultMessage: 'Ambient (Room Temperature)',
  },
  _PC_PLATE_SPECIFICATIONS_ICE: {
    id: '_PC_PLATE_SPECIFICATIONS_ICE',
    defaultMessage: 'Ice Packs (Cool)',
  },
  _PC_PLATE_SPECIFICATIONS_DRY_ICE: {
    id: '_PC_PLATE_SPECIFICATIONS_DRY_ICE',
    defaultMessage: 'Dry Ice (Frozen)',
  },
  _PC_PROPERTY_DISPLAY_INSOL_OTHER_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_OTHER_screen',
    defaultMessage: 'In Solution (Other)',
  },
  _PC_SPEC_3MOD: { id: '_PC_SPEC_3MOD', defaultMessage: "3' Modifications" },
  _PC_SPEC_5MOD: { id: '_PC_SPEC_5MOD', defaultMessage: "5' Modifications" },
  _PC_SPEC_YEILD: { id: '_PC_SPEC_YEILD', defaultMessage: 'Amount' },
  _PC_SPEC_1_D: { id: '_PC_SPEC_1_D', defaultMessage: '1 OD' },
  _PC_SPEC_3_D: { id: '_PC_SPEC_3_D', defaultMessage: '3 OD' },
  _PC_SPEC_5_D: { id: '_PC_SPEC_5_D', defaultMessage: '5 OD' },
  _PC_SPEC_10_D: { id: '_PC_SPEC_10_D', defaultMessage: '10 OD' },
  _PC_SPEC_50_D: { id: '_PC_SPEC_50_D', defaultMessage: '50 OD' },
  _PC_SPEC_100_D: { id: '_PC_SPEC_100_D', defaultMessage: '100 OD' },
  _PC_SPEC_REP_QUEN: {
    id: '_PC_SPEC_REP_QUEN',
    defaultMessage: "5' Reporter / 3' Quencher Combination",
  },
  _PC_SPEC_BASES: { id: '_PC_SPEC_BASES', defaultMessage: 'Optional Bases' },
  _PC_SPEC_6FAM_BHQ1: {
    id: '_PC_SPEC_6FAM_BHQ1',
    defaultMessage: '6-FAM / BHQ-1',
  },
  _PC_SPEC_6FAM_TAMRA: {
    id: '_PC_SPEC_6FAM_TAMRA',
    defaultMessage: '6-FAM / TAMRA',
  },
  _PC_SPEC_HEX_BHQ1: { id: '_PC_SPEC_HEX_BHQ1', defaultMessage: 'HEX / BHQ-1' },
  _PC_SPEC_HEX_TAMRA: {
    id: '_PC_SPEC_HEX_TAMRA',
    defaultMessage: 'HEX / TAMRA',
  },
  _PC_SPEC_JOE_BHQ1: { id: '_PC_SPEC_JOE_BHQ1', defaultMessage: 'JOE / BHQ-1' },
  _PC_SPEC_JOE_TAMRA: {
    id: '_PC_SPEC_JOE_TAMRA',
    defaultMessage: 'JOE / TAMRA',
  },
  _PC_SPEC_TEXAS_BHQ2: {
    id: '_PC_SPEC_TEXAS_BHQ2',
    defaultMessage: 'TxRd / BHQ-2',
  },
  _PC_SPEC_ROX_BHQ2: { id: '_PC_SPEC_ROX_BHQ2', defaultMessage: 'ROX / BHQ-2' },
  _PC_SPEC_CY5_BHQ3: {
    id: '_PC_SPEC_CY5_BHQ3',
    defaultMessage: 'Cyanine 5 / BHQ-3',
  },
  _PC_SPEC_CY5_BHQ2: {
    id: '_PC_SPEC_CY5_BHQ2',
    defaultMessage: 'Cyanine 5 / BHQ-2',
  },
  _PC_SPEC_CY5_OQD: {
    id: '_PC_SPEC_CY5_OQD',
    defaultMessage: 'Cyanine 5 / Onyx Quencher D',
  },
  _PC_SPEC_CY3_BHQ2: {
    id: '_PC_SPEC_CY3_BHQ2',
    defaultMessage: 'Cyanine 3 / BHQ-2',
  },
  _PC_SPEC_CY3_OQB: {
    id: '_PC_SPEC_CY3_OQB',
    defaultMessage: 'Cyanine 3 / Onyx Quencher B',
  },
  _PC_SPEC_TET_BHQ1: { id: '_PC_SPEC_TET_BHQ1', defaultMessage: 'TET / BHQ-1' },
  _PC_SPEC_TET_TAMRA: {
    id: '_PC_SPEC_TET_TAMRA',
    defaultMessage: 'TET / TAMRA',
  },
  _PC_SPEC_TET_OQA: {
    id: '_PC_SPEC_TET_OQA',
    defaultMessage: 'TET / Onyx Quencher A',
  },
  _PC_SPEC_TAM_BHQ2: {
    id: '_PC_SPEC_TAM_BHQ2',
    defaultMessage: 'TAMRA / BHQ-2',
  },
  _PC_SPEC_CY55_BHQ2: {
    id: '_PC_SPEC_CY55_BHQ2',
    defaultMessage: 'Cyanine 5.5 / BHQ-2',
  },
  _PC_SPEC_CY55_BHQ3: {
    id: '_PC_SPEC_CY55_BHQ3',
    defaultMessage: 'Cyanine 5.5 / BHQ-3',
  },
  _PC_SPEC_CY55_OQD: {
    id: '_PC_SPEC_CY55_OQD',
    defaultMessage: 'Cyanine 5.5 / Onyx Quencher D',
  },
  _PC_SPEC_CFO560_BHQ1: {
    id: '_PC_SPEC_CFO560_BHQ1',
    defaultMessage: 'Cal Fluor Orange 560 / BHQ-1',
  },
  _PC_SPEC_CFG540_BHQ1: {
    id: '_PC_SPEC_CFG540_BHQ1',
    defaultMessage: 'Cal Fluor Gold 540 / BHQ-1',
  },
  _PC_SPEC_CFR590_BHQ2: {
    id: '_PC_SPEC_CFR590_BHQ2',
    defaultMessage: 'Cal Fluor Red 590 / BHQ-2',
  },
  _PC_SPEC_Q570_BHQ2: {
    id: '_PC_SPEC_Q570_BHQ2',
    defaultMessage: 'Quasar 570 / BHQ-2',
  },
  _PC_SPEC_Q670_BHQ3: {
    id: '_PC_SPEC_Q670_BHQ3',
    defaultMessage: 'Quasar 670 / BHQ-3',
  },
  _PC_SPEC_6FAM_OQA: {
    id: '_PC_SPEC_6FAM_OQA',
    defaultMessage: '6-FAM / Onyx Quencher A',
  },
  _PC_SPEC_HEX_OQA: {
    id: '_PC_SPEC_HEX_OQA',
    defaultMessage: 'HEX / Onyx Quencher A',
  },
  _PC_SPEC_JOE_OQA: {
    id: '_PC_SPEC_JOE_OQA',
    defaultMessage: 'JOE / Onyx Quencher A',
  },
  _PC_SPEC_TAM_OQB: {
    id: '_PC_SPEC_TAM_OQB',
    defaultMessage: 'TAMRA / Onyx Quencher B',
  },
  _PC_SPEC_ROX_OQC: {
    id: '_PC_SPEC_ROX_OQC',
    defaultMessage: 'ROX / Onyx Quencher C',
  },
  _PC_SPEC_TEXAS_OQC: {
    id: '_PC_SPEC_TEXAS_OQC',
    defaultMessage: 'TxRd / Onyx Quencher C',
  },
  _PC_SPEC_MODIFIES_SCALE: {
    id: '_PC_SPEC_MODIFIES_SCALE',
    defaultMessage:
      '* Guarantee is for 20mer or longer. Shorter oligos may have fewer ODs. Microgram amounts are calculated based on a 30 µg/OD value.  If the µg/OD value is less than 30, the reported µg value will be proportionally less. Note: Post-synthesis modifications may yield 50% less than the above stated values. Phosphorothioated yields are 70% of the above stated guarantees.',
  },
  _PC_SPEC_AMOUNT: { id: '_PC_SPEC_AMOUNT', defaultMessage: 'Amount' },
  _PC_SPEC_PURITY_LEVEL: {
    id: '_PC_SPEC_PURITY_LEVEL',
    defaultMessage: 'Purity Level ',
  },
  _PC_SPEC_QUANTITATION: {
    id: '_PC_SPEC_QUANTITATION',
    defaultMessage: 'Quantitation',
  },
  _PC_SPEC_LABELED_AMINO_ACIDS: {
    id: '_PC_SPEC_LABELED_AMINO_ACIDS',
    defaultMessage: 'Labeled Amino Acids',
  },
  _PC_SPEC_N_TERMINAL_MOD: {
    id: '_PC_SPEC_N_TERMINAL_MOD',
    defaultMessage: 'N-Terminal Modifications',
  },
  _PC_SPEC_INTERNALMODS: {
    id: '_PC_SPEC_INTERNALMODS',
    defaultMessage: 'Internal Modifications',
  },
  _PC_SPEC_C_TERMINAL_MOD: {
    id: '_PC_SPEC_C_TERMINAL_MOD',
    defaultMessage: 'C-Terminal Modifications',
  },
  _PC_SPEC_F_C13N15: {
    id: '_PC_SPEC_F_C13N15',
    defaultMessage: '[F_C13N15] = Phenylalanine_C13N15',
  },
  _PC_SPEC_I_C13N15: {
    id: '_PC_SPEC_I_C13N15',
    defaultMessage: '[I_C13N15] = Isoleucine_C13N15',
  },
  _PC_SPEC_K_C13N15: {
    id: '_PC_SPEC_K_C13N15',
    defaultMessage: '[K_C13N15] = Lysine_C13N15',
  },
  _PC_SPEC_L_C13N15: {
    id: '_PC_SPEC_L_C13N15',
    defaultMessage: '[L_C13N15] = Leucine_C13N15',
  },
  _PC_SPEC_P_C13N15: {
    id: '_PC_SPEC_P_C13N15',
    defaultMessage: '[P_C13N15] = Proline_C13N15',
  },
  _PC_SPEC_R_C13N15: {
    id: '_PC_SPEC_R_C13N15',
    defaultMessage: '[R_C13N15] = Arginine_C13N15',
  },
  _PC_SPEC_V_C13N15: {
    id: '_PC_SPEC_V_C13N15',
    defaultMessage: '[V_C13N15] = Valine_C13N15',
  },
  _PC_SPEC_PSER: {
    id: '_PC_SPEC_PSER',
    defaultMessage: '[pSer] = Phosphoserine',
  },
  _PC_SPEC_PTHR: {
    id: '_PC_SPEC_PTHR',
    defaultMessage: '[pThr] = Phosphothreonine',
  },
  _PC_SPEC_PTYR: {
    id: '_PC_SPEC_PTYR',
    defaultMessage: '[pTyr] = Phosphotyrosine',
  },
  _PC_SPEC_CM_CYS: {
    id: '_PC_SPEC_CM_CYS',
    defaultMessage: '[CM_Cys] = Carboxymethylated Cys',
  },
  _PC_SPEC_CAM: {
    id: '_PC_SPEC_CAM',
    defaultMessage: '[CAM] = Carbamidomethylated Cys',
  },
  _PC_SPEC_K_UBQ: {
    id: '_PC_SPEC_K_UBQ',
    defaultMessage: '[K_Ubq] = Ubiquitinated Lysine',
  },
  _PC_SPEC_HYP: {
    id: '_PC_SPEC_HYP',
    defaultMessage: '[Hyp] = Hydroxyproline',
  },
  _PC_SPEC_ACE_K: {
    id: '_PC_SPEC_ACE_K',
    defaultMessage: '[ace-K] = Acetylated Lysine',
  },
  _PC_SPEC_KME2: {
    id: '_PC_SPEC_KME2',
    defaultMessage: '[K-Me2] = Dimethylated Lysine',
  },
  _PC_SPEC_NIT_Y: {
    id: '_PC_SPEC_NIT_Y',
    defaultMessage: '[Nit-Y] = Nitrotyrosine',
  },
  _PC_SPEC_C_ACM: {
    id: '_PC_SPEC_C_ACM',
    defaultMessage: '[C-acm] = Acetomidomethylated Cys',
  },
  _PC_SPEC_PGLU: {
    id: '_PC_SPEC_PGLU',
    defaultMessage: '[pGlu] = Pyroglutamic acid',
  },
  _PC_SPEC_METO: {
    id: '_PC_SPEC_METO',
    defaultMessage: '[MetO] = Methionine Sulfoxide',
  },
  _PC_SPEC_H_aqua: {
    id: '_PC_SPEC_H_aqua',
    defaultMessage: '[H] = Free Amine',
  },
  _PC_SPEC_ACE: { id: '_PC_SPEC_ACE', defaultMessage: '[Ace] = Acetylation' },
  _PC_SPEC_Btn: {
    id: '_PC_SPEC_Btn',
    defaultMessage: '[Btn] = Biotin (includes Ahx spacer)',
  },
  _PC_SPEC_OH: { id: '_PC_SPEC_OH', defaultMessage: '[OH] = Free Acid' },
  _PC_SPEC_NH2: { id: '_PC_SPEC_NH2', defaultMessage: '[NH2] = Amidation' },
  _PC_SPEC_Ahx: { id: '_PC_SPEC_Ahx', defaultMessage: 'Aminohexanoic acid' },
  _PC_SPEC_10_NMOL_2_D: {
    id: '_PC_SPEC_10_NMOL_2_D',
    defaultMessage: '10 nmol (2 OD)',
  },
  _PC_SPEC_25_NMOL_5_D: {
    id: '_PC_SPEC_25_NMOL_5_D',
    defaultMessage: '25 nmol (5 OD)',
  },
  _PC_SPEC_50_NMOL_10_D: {
    id: '_PC_SPEC_50_NMOL_10_D',
    defaultMessage: '50 nmol (10 OD)',
  },
  _PC_SPEC_250_NMOL_50_D: {
    id: '_PC_SPEC_250_NMOL_50_D',
    defaultMessage: '250 nmol (50 OD)',
  },
  _PC_SPEC_6FAM: { id: '_PC_SPEC_6FAM', defaultMessage: '6-FAM' },
  _PC_SPEC_5_Biotin: { id: '_PC_SPEC_5_Biotin', defaultMessage: 'Biotin' },
  _PC_SPEC_Cyanine3: { id: '_PC_SPEC_Cyanine3', defaultMessage: 'Cyanine 3' },
  _PC_SPEC_Cyanine5: { id: '_PC_SPEC_Cyanine5', defaultMessage: 'Cyanine 5' },
  _PC_SPEC_Cyanine55: {
    id: '_PC_SPEC_Cyanine55',
    defaultMessage: 'Cyanine 5.5',
  },
  _PC_SPEC_Invert_Abasic: {
    id: '_PC_SPEC_Invert_Abasic',
    defaultMessage: 'Inverted Abasic',
  },
  _PC_SPEC_Thiol_Modifier_C6_S_S: {
    id: '_PC_SPEC_Thiol_Modifier_C6_S_S',
    defaultMessage: 'Thiol-Modifier C6 S-S',
  },
  _PC_SPEC_THIC3: {
    id: '_PC_SPEC_THIC3',
    defaultMessage: 'Thiol-Modifier C3 S-S',
  },
  _PC_SPEC_G_5_Inverse_Oligo: {
    id: '_PC_SPEC_G_5_Inverse_Oligo',
    defaultMessage: 'Inverted dT',
  },
  _PC_SPEC_NON_MODIFIED_OLIGOS_ST: {
    id: '_PC_SPEC_NON_MODIFIED_OLIGOS_ST',
    defaultMessage: 'Non-Modified Phosphorothioates(S-Oligos)(O.D./µg)*',
  },
  _PC_YIELD_RECOMMEND_NOTE_BEACON: {
    id: '_PC_YIELD_RECOMMEND_NOTE_BEACON',
    defaultMessage:
      '*Estimate is based on 3 nmoles or 32 µg for 1 OD and 200 nM in 25 µl reaction (5.0 pmol/reaction). Estimate is based on an average sequence length of 30 bases.',
  },
  _PC_PLATE_SH_No_dnaplate: {
    id: '_PC_PLATE_SH_No_dnaplate',
    defaultMessage: 'No, do not send',
  },
  _PC_PLATE_SH_Yes_dnaplate: {
    id: '_PC_PLATE_SH_Yes_dnaplate',
    defaultMessage: 'Yes, send remaining material (Additional fees may apply)',
  },
  _PC_PLATE_SPECIFICATIONS_RP1: {
    id: '_PC_PLATE_SPECIFICATIONS_RP1',
    defaultMessage: 'Cartridge',
  },
  _PC_PLATE_SPECIFICATIONS_HPLC: {
    id: '_PC_PLATE_SPECIFICATIONS_HPLC',
    defaultMessage: 'HPLC',
  },
  _PC_PLATE_SPECIFICATIONS_PAGE: {
    id: '_PC_PLATE_SPECIFICATIONS_PAGE',
    defaultMessage: 'PAGE',
  },
  _PC_PLATE_SPECIFICATIONS_DRY: {
    id: '_PC_PLATE_SPECIFICATIONS_DRY',
    defaultMessage: 'Dry',
  },
  _PC_PLATE_SPECIFICATIONS_LIQUID: {
    id: '_PC_PLATE_SPECIFICATIONS_LIQUID',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_PLATE_SPECIFICATIONS_TE: {
    id: '_PC_PLATE_SPECIFICATIONS_TE',
    defaultMessage: 'In Solution (TE)',
  },
  _PC_PLATE_SPECIFICATIONS_TRIS: {
    id: '_PC_PLATE_SPECIFICATIONS_TRIS',
    defaultMessage: 'In Solution (TRIS)',
  },
  _PC_SPEC_D2_PA: {
    id: '_PC_SPEC_D2_PA',
    defaultMessage: '[D2-PA] = WellRED D2-PA',
  },
  _PC_SPEC_D3_PA: {
    id: '_PC_SPEC_D3_PA',
    defaultMessage: '[D3-PA] = WellRED D3-PA',
  },
  _PC_SPEC_D4_PA: {
    id: '_PC_SPEC_D4_PA',
    defaultMessage: '[D4-PA] = WellRED D4-PA',
  },
  _PC_SPEC_2_D: { id: '_PC_SPEC_2_D', defaultMessage: '2 OD' },
  _PC_SPEC_4_D: { id: '_PC_SPEC_4_D', defaultMessage: '4 OD' },
  _PC_SPEC_20_D: { id: '_PC_SPEC_20_D', defaultMessage: '20 OD' },
  _PC_SPEC_40_D: { id: '_PC_SPEC_40_D', defaultMessage: '40 OD' },
  _PC_SPEC_R1_CATRIDGE: {
    id: '_PC_SPEC_R1_CATRIDGE',
    defaultMessage: 'Cartridge',
  },
  _PC_SPEC_LOCKED_BASE_A: {
    id: '_PC_SPEC_LOCKED_BASE_A',
    defaultMessage: '[+A] - Locked Base A',
  },
  _PC_SPEC_LOCKED_BASE_C: {
    id: '_PC_SPEC_LOCKED_BASE_C',
    defaultMessage: '[+C] - Locked Base C',
  },
  _PC_SPEC_LOCKED_BASE_G: {
    id: '_PC_SPEC_LOCKED_BASE_G',
    defaultMessage: '[+G] - Locked Base G',
  },
  _PC_SPEC_LOCKED_BASE_T: {
    id: '_PC_SPEC_LOCKED_BASE_T',
    defaultMessage: '[+T] - Locked Base T',
  },
  _PC_SPEC_K_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_K_DNA_DEGENERATE_BASE',
    defaultMessage: 'K (G,T)',
  },
  _PC_SPEC_H_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_H_DNA_DEGENERATE_BASE',
    defaultMessage: 'H (A,T,C)',
  },
  _PC_SPEC_D_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_D_DNA_DEGENERATE_BASE',
    defaultMessage: 'D (A,G,T)',
  },
  _PC_SPEC_Y_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_Y_DNA_DEGENERATE_BASE',
    defaultMessage: 'Y (C,T)',
  },
  _PC_SPEC_S_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_S_DNA_DEGENERATE_BASE',
    defaultMessage: 'S (C,G)',
  },
  _PC_SPEC_B_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_B_DNA_DEGENERATE_BASE',
    defaultMessage: 'B (C,G,T)',
  },
  _PC_SPEC_N_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_N_DNA_DEGENERATE_BASE',
    defaultMessage: 'N (A,C,G,T)',
  },
  _PC_SPEC_M_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_M_DNA_DEGENERATE_BASE',
    defaultMessage: 'M (A,C)',
  },
  _PC_SPEC_W_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_W_DNA_DEGENERATE_BASE',
    defaultMessage: 'W (A,T)',
  },
  _PC_SPEC_V_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_V_DNA_DEGENERATE_BASE',
    defaultMessage: 'V (A,C,G)',
  },
  _PC_SPEC_R_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_R_DNA_DEGENERATE_BASE',
    defaultMessage: 'R (A,G)',
  },
  _PC_SPEC_DEOXYURIDINE: {
    id: '_PC_SPEC_DEOXYURIDINE',
    defaultMessage: 'U (deoxyUridine)',
  },
  _PC_SPEC_INOSINE: {
    id: '_PC_SPEC_INOSINE',
    defaultMessage: 'I (deoxyInosine)',
  },
  _PC_SPEC_2_OMe_A: { id: '_PC_SPEC_2_OMe_A', defaultMessage: '2-OMe-RNA A' },
  _PC_SPEC_2_OMe_C: { id: '_PC_SPEC_2_OMe_C', defaultMessage: '2-OMe-RNA C' },
  _PC_SPEC_2_OMe_G: { id: '_PC_SPEC_2_OMe_G', defaultMessage: '2-OMe-RNA G' },
  _PC_SPEC_2_OMe_U: { id: '_PC_SPEC_2_OMe_U', defaultMessage: '2-OMe-RNA U' },
  _PC_SPEC_R: { id: '_PC_SPEC_R', defaultMessage: 'R (A,G)' },
  _PC_SPEC_K: { id: '_PC_SPEC_K', defaultMessage: 'K (G,U)' },
  _PC_SPEC_H: { id: '_PC_SPEC_H', defaultMessage: 'H (A,U,C)' },
  _PC_SPEC_D: { id: '_PC_SPEC_D', defaultMessage: 'D (A,G,U)' },
  _PC_SPEC_Y: { id: '_PC_SPEC_Y', defaultMessage: 'Y (C,U)' },
  _PC_SPEC_S: { id: '_PC_SPEC_S', defaultMessage: 'S (C,G)' },
  _PC_SPEC_B: { id: '_PC_SPEC_B', defaultMessage: 'B (C,G,U)' },
  _PC_SPEC_N: { id: '_PC_SPEC_N', defaultMessage: 'N (A,C,G,U)' },
  _PC_SPEC_M: { id: '_PC_SPEC_M', defaultMessage: 'M (A,C)' },
  _PC_SPEC_W: { id: '_PC_SPEC_W', defaultMessage: 'W (A,U)' },
  _PC_SPEC_V: { id: '_PC_SPEC_V', defaultMessage: 'V (A,C,G)' },
  _PC_SPEC_BASE_dA: {
    id: '_PC_SPEC_BASE_dA',
    defaultMessage: '[dA]-DNA Base A',
  },
  _PC_SPEC_BASE_dC: {
    id: '_PC_SPEC_BASE_dC',
    defaultMessage: '[dC]-DNA Base C',
  },
  _PC_SPEC_BASE_dG: {
    id: '_PC_SPEC_BASE_dG',
    defaultMessage: '[dG]-DNA Base G',
  },
  _PC_SPEC_BASE_dT: {
    id: '_PC_SPEC_BASE_dT',
    defaultMessage: '[dT]-DNA Base T',
  },
  _PC_SPEC_DEOXYURIDINE_RNA: {
    id: '_PC_SPEC_DEOXYURIDINE_RNA',
    defaultMessage: '[dU] (deoxyUridine)',
  },
  _PC_SPEC_INOSINE_RNA: {
    id: '_PC_SPEC_INOSINE_RNA',
    defaultMessage: '[dI] (deoxyInosine)',
  },
  _PC_SPEC_2Flouro_A: {
    id: '_PC_SPEC_2Flouro_A',
    defaultMessage: "2'-Fluoro A",
  },
  _PC_SPEC_2Flouro_C: {
    id: '_PC_SPEC_2Flouro_C',
    defaultMessage: "2'-Fluoro C",
  },
  _PC_SPEC_2Flouro_G: {
    id: '_PC_SPEC_2Flouro_G',
    defaultMessage: "2'-Fluoro G",
  },
  _PC_SPEC_2Flouro_U: {
    id: '_PC_SPEC_2Flouro_U',
    defaultMessage: "2'-Fluoro U",
  },
  _PC_SPEC_0_0250_UMO: {
    id: '_PC_SPEC_0_0250_UMO',
    defaultMessage: '0.025 µmole',
  },
  _PC_SPEC_0_0500_UMO: {
    id: '_PC_SPEC_0_0500_UMO',
    defaultMessage: '0.05 µmole',
  },
  _PC_SPEC_0_2000_UMO: {
    id: '_PC_SPEC_0_2000_UMO',
    defaultMessage: '0.2 µmole',
  },
  _PC_SPEC_1_0000_UMO: { id: '_PC_SPEC_1_0000_UMO', defaultMessage: '1 µmole' },
  _PC_SPEC_10_0000_UMO: {
    id: '_PC_SPEC_10_0000_UMO',
    defaultMessage: '10 µmole',
  },
  _PC_SPEC_15_0000_UMO: {
    id: '_PC_SPEC_15_0000_UMO',
    defaultMessage: '15 µmole',
  },
  _PC_SPEC_D1_D: { id: '_PC_SPEC_D1_D', defaultMessage: '0.1 OD' },
  _PC_SPEC_D25_D: { id: '_PC_SPEC_D25_D', defaultMessage: '0.25 OD' },
  _PC_SPEC_1D5_D: { id: '_PC_SPEC_1D5_D', defaultMessage: '1.5 OD' },
  _PC_SPEC_15_D: { id: '_PC_SPEC_15_D', defaultMessage: '15 OD' },
  _PC_SPEC_dT_dT: { id: '_PC_SPEC_dT_dT', defaultMessage: '[dT][dT]' },
  _PC_SPEC_UU: { id: '_PC_SPEC_UU', defaultMessage: 'UU' },
  _PC_SPEC_A: { id: '_PC_SPEC_A', defaultMessage: 'A' },
  _PC_SPEC_C: { id: '_PC_SPEC_C', defaultMessage: 'C' },
  _PC_SPEC_G: { id: '_PC_SPEC_G', defaultMessage: 'G' },
  _PC_SPEC_T: { id: '_PC_SPEC_T', defaultMessage: 'T' },
  _PC_SPEC_A_LNA_BASE: {
    id: '_PC_SPEC_A_LNA_BASE',
    defaultMessage: '[+A] - LNA Base A',
  },
  _PC_SPEC_C_LNA_BASE: {
    id: '_PC_SPEC_C_LNA_BASE',
    defaultMessage: '[+C] - LNA Base C',
  },
  _PC_SPEC_G_LNA_BASE: {
    id: '_PC_SPEC_G_LNA_BASE',
    defaultMessage: '[+G] - LNA Base G',
  },
  _PC_SPEC_T_LNA_BASE: {
    id: '_PC_SPEC_T_LNA_BASE',
    defaultMessage: '[+T] - LNA Base T',
  },
  _PC_SPEC_dT_dG: { id: '_PC_SPEC_dT_dG', defaultMessage: '[dT][dG]' },
  _PC_SPEC_dT_dC: { id: '_PC_SPEC_dT_dC', defaultMessage: '[dT][dC]' },
  _PC_SPEC_dT_dA: { id: '_PC_SPEC_dT_dA', defaultMessage: '[dT][dA]' },
  _PC_SPEC_dG_dT: { id: '_PC_SPEC_dG_dT', defaultMessage: '[dG][dT]' },
  _PC_SPEC_dG_dG: { id: '_PC_SPEC_dG_dG', defaultMessage: '[dG][dG]' },
  _PC_SPEC_dG_dC: { id: '_PC_SPEC_dG_dC', defaultMessage: '[dG][dC]' },
  _PC_SPEC_dG_dA: { id: '_PC_SPEC_dG_dA', defaultMessage: '[dG][dA]' },
  _PC_SPEC_dC_dT: { id: '_PC_SPEC_dC_dT', defaultMessage: '[dC][dT]' },
  _PC_SPEC_dC_dG: { id: '_PC_SPEC_dC_dG', defaultMessage: '[dC][dG]' },
  _PC_SPEC_dA_dA: { id: '_PC_SPEC_dA_dA', defaultMessage: '[dA][dA]' },
  _PC_SPEC_dC_dC: { id: '_PC_SPEC_dC_dC', defaultMessage: '[dC][dC]' },
  _PC_SPEC_dC_dA: { id: '_PC_SPEC_dC_dA', defaultMessage: '[dC][dA]' },
  _PC_SPEC_dA_dT: { id: '_PC_SPEC_dA_dT', defaultMessage: '[dA][dT]' },
  _PC_SPEC_dA_dG: { id: '_PC_SPEC_dA_dG', defaultMessage: '[dA][dG]' },
  _PC_SPEC_dA_dC: { id: '_PC_SPEC_dA_dC', defaultMessage: '[dA][dC]' },
  _PC_SPEC_dT__dT: { id: '_PC_SPEC_dT__dT', defaultMessage: '[dT]*[dT]' },
  _PC_SPEC_NONE_VALUE: { id: '_PC_SPEC_NONE_VALUE', defaultMessage: 'None' },
  _PC_SPEC_3_AmC7: {
    id: '_PC_SPEC_3_AmC7',
    defaultMessage: '3-Amino-Modifier-C6',
  },
  _PC_SPEC_3_Amino_Modifier_C6: {
    id: '_PC_SPEC_3_Amino_Modifier_C6',
    defaultMessage: 'Amino-Modifier C6',
  },
  _PC_SPEC_5_Btn: { id: '_PC_SPEC_5_Btn', defaultMessage: '5-Biotin' },
  _PC_DUPLEX_Cyanine3: {
    id: '_PC_DUPLEX_Cyanine3',
    defaultMessage: 'Cyanine 3',
  },
  _PC_DUPLEX_Cyanine5: {
    id: '_PC_DUPLEX_Cyanine5',
    defaultMessage: 'Cyanine 5',
  },
  _PC_SPEC_Cyanine5_5: {
    id: '_PC_SPEC_Cyanine5_5',
    defaultMessage: 'Cyanine55',
  },
  _PC_SPEC_dT5F: { id: '_PC_SPEC_dT5F', defaultMessage: 'Flipped base' },
  _PC_SPEC_FLUORESCEIN: {
    id: '_PC_SPEC_FLUORESCEIN',
    defaultMessage: 'Fluorescein',
  },
  _PC_SPEC_InvAb: { id: '_PC_SPEC_InvAb', defaultMessage: 'Inverted Abasic' },
  _PC_SPEC_Phos: { id: '_PC_SPEC_Phos', defaultMessage: 'Phosphate' },
  _PC_SPEC_MOD_6FAM: { id: '_PC_SPEC_MOD_6FAM', defaultMessage: '6-FAM' },
  _PC_SPEC_ATTACHMENT_THC6_SS: {
    id: '_PC_SPEC_ATTACHMENT_THC6_SS',
    defaultMessage: 'Thiol-Modifier-C6 S-S',
  },
  _PC_SPEC_TUBES: { id: '_PC_SPEC_TUBES', defaultMessage: 'Tubes' },
  _PC_SPEC_10_mg: { id: '_PC_SPEC_10_mg', defaultMessage: '10 mg' },
  _PC_SPEC_25_mg: { id: '_PC_SPEC_25_mg', defaultMessage: '25 mg' },
  _PC_SPEC_50_mg: { id: '_PC_SPEC_50_mg', defaultMessage: '50 mg' },
  _PC_SPEC_100_mg: { id: '_PC_SPEC_100_mg', defaultMessage: '100 mg' },
  _PC_SPEC_2_000_mg: { id: 'PC_SPEC_2_000_mg', defaultMessage: '2 mg' },
  _PC_SPEC_3_000_mg: { id: 'PC_SPEC_3_000_mg', defaultMessage: '3 mg' },
  _PC_SPEC_5_000_mg: { id: 'PC_SPEC_5_000_mg', defaultMessage: '5 mg' },
  _PC_SPEC_10_000_mg: { id: 'PC_SPEC_10_000_mg', defaultMessage: '10 mg' },
  _PC_SPEC_25_000_mg: { id: 'PC_SPEC_25_000_mg', defaultMessage: '25 mg' },
  _PC_SPEC_50_000_mg: { id: 'PC_SPEC_50_000_mg', defaultMessage: '50 mg' },
  _PC_SPEC_100_000_mg: { id: 'PC_SPEC_100_000_mg', defaultMessage: '100 mg' },
  _PC_PROPERTY_DISPLAY_Unpurified_screen: {
    id: '_PC_PROPERTY_DISPLAY_Unpurified_screen',
    defaultMessage: 'Unpurified',
  },
  _PC_SPEC_2_OD: { id: '_PC_SPEC_2_OD', defaultMessage: '10 nmol (2 OD)' },
  _PC_SPEC_5_OD: { id: '_PC_SPEC_5_OD', defaultMessage: '25 nmol (5 OD)' },
  _PC_SPEC_10_OD: { id: '_PC_SPEC_10_OD', defaultMessage: '50 nmol (10 OD)' },
  _PC_SPEC_50_OD: { id: '_PC_SPEC_50_OD', defaultMessage: '250 nmol (50 OD)' },
  _PC_SPEC_10: { id: '_PC_SPEC_10', defaultMessage: '10 mg' },
  _PC_SPEC_25: { id: '_PC_SPEC_25', defaultMessage: '25 mg' },
  _PC_SPEC_50: { id: '_PC_SPEC_50', defaultMessage: '50 mg' },
  _PC_SPEC_100: { id: '_PC_SPEC_100', defaultMessage: '100 mg' },
  _PC_SPEC_250: { id: '_PC_SPEC_250', defaultMessage: '250 mg' },
  _PC_SPEC_500: { id: '_PC_SPEC_500', defaultMessage: '500 mg' },
  _PC_SPEC_1000: { id: '_PC_SPEC_1000', defaultMessage: '1000 mg' },
  _PC_SPEC_amount_10: { id: '_PC_SPEC_amount_10', defaultMessage: '10 mg' },
  _PC_SPEC_amount_25: { id: '_PC_SPEC_amount_25', defaultMessage: '25 mg' },
  _PC_SPEC_amount_50: { id: '_PC_SPEC_amount_50', defaultMessage: '50 mg' },
  _PC_SPEC_amount_100: { id: '_PC_SPEC_amount_100', defaultMessage: '100 mg' },
  _PC_SPEC_amount_250: { id: '_PC_SPEC_amount_250', defaultMessage: '250 mg' },
  _PC_SPEC_amount_500: { id: '_PC_SPEC_amount_500', defaultMessage: '500 mg' },
  _PC_SPEC_amount_1000: {
    id: '_PC_SPEC_amount_1000',
    defaultMessage: '1000 mg',
  },
  _PC_SPEC_amount_2000: {
    id: '_PC_SPEC_amount_2000',
    defaultMessage: '2000 mg',
  },
  _PC_SPEC_amount_5000: {
    id: '_PC_SPEC_amount_5000',
    defaultMessage: '5000 mg',
  },
  _PC_SPEC_amount_10000: {
    id: '_PC_SPEC_amount_10000',
    defaultMessage: '10000 mg',
  },
  _PC_SPEC_amount_15000: {
    id: '_PC_SPEC_amount_15000',
    defaultMessage: '15000 mg',
  },
  _PC_SPEC_2000: { id: '_PC_SPEC_2000', defaultMessage: '2000 mg' },
  _PC_SPEC_5000: { id: '_PC_SPEC_5000', defaultMessage: '5000 mg' },
  _PC_SPEC_10000: { id: '_PC_SPEC_10000', defaultMessage: '10000 mg' },
  _PC_SPEC_15000: { id: '_PC_SPEC_15000', defaultMessage: '15000 mg' },
  _PC_SPEC_DEOXYURIDINE_DUPLEX: {
    id: '_PC_SPEC_DEOXYURIDINE_DUPLEX',
    defaultMessage: '[dU]-DeoxyUridine',
  },
  _PC_SPEC_2_FLA: {
    id: '_PC_SPEC_2_FLA',
    defaultMessage: "[2flA]-2'- Fluoro A",
  },
  _PC_SPEC_2_FLC: {
    id: '_PC_SPEC_2_FLC',
    defaultMessage: "[2flC]-2'- Fluoro C",
  },
  _PC_SPEC_2_FLG: {
    id: '_PC_SPEC_2_FLG',
    defaultMessage: "[2flG]-2'- Fluoro G",
  },
  _PC_SPEC_2_FLU: {
    id: '_PC_SPEC_2_FLU',
    defaultMessage: "[2flU]-2'- Fluoro U",
  },
  _PC_SPEC_BASE_mA: {
    id: '_PC_SPEC_BASE_mA',
    defaultMessage: "[mA]-2'-OMe RNA Base A",
  },
  _PC_SPEC_BASE_mC: {
    id: '_PC_SPEC_BASE_mC',
    defaultMessage: "[mC]-2'-OMe RNA Base C",
  },
  _PC_SPEC_BASE_mG: {
    id: '_PC_SPEC_BASE_mG',
    defaultMessage: "[mG]-2'-OMe RNA Base G",
  },
  _PC_SPEC_BASE_mU: {
    id: '_PC_SPEC_BASE_mU',
    defaultMessage: "[mU]-2'-OMe RNA Base U",
  },
  _PC_SPEC_BASE_dC_duplex: {
    id: '_PC_SPEC_BASE_dC_duplex',
    defaultMessage: '[dC]-DNA Base C',
  },
  _PC_SPEC_BASE_dT_duplex: {
    id: '_PC_SPEC_BASE_dT_duplex',
    defaultMessage: '[dT]-DNA Base T',
  },
  _PC_SPEC_6FAM_DABC: {
    id: '_PC_SPEC_6FAM_DABC',
    defaultMessage: '6-FAM / Dabcyl',
  },
  _PC_SPEC_HEX_DABC: {
    id: '_PC_SPEC_HEX_DABC',
    defaultMessage: 'HEX / Dabcyl',
  },
  _PC_SPEC_TEXAS_DABC: {
    id: '_PC_SPEC_TEXAS_DABC',
    defaultMessage: 'TxRd / Dabcyl',
  },
  _PC_SPEC_JOE_DABC: {
    id: '_PC_SPEC_JOE_DABC',
    defaultMessage: 'JOE / Dabcyl',
  },
  _PC_SPEC_CY5_DABC: {
    id: '_PC_SPEC_CY5_DABC',
    defaultMessage: 'Cyanine 5 / Dabcyl',
  },
  _PC_SPEC_CY55_DABC: {
    id: '_PC_SPEC_CY55_DABC',
    defaultMessage: 'Cyanine 5.5 / Dabcyl',
  },
  _PC_SPEC_TET_DABC: {
    id: '_PC_SPEC_TET_DABC',
    defaultMessage: 'TET / Dabcyl',
  },
  _PC_SPEC_CY3_DABC: {
    id: '_PC_SPEC_CY3_DABC',
    defaultMessage: 'Cyanine 3 / Dabcyl',
  },
  _PC_SPEC_ROX_DABC: {
    id: '_PC_SPEC_ROX_DABC',
    defaultMessage: 'ROX / Dabcyl',
  },
  _PC_SPEC_DEOXYURIDINE_BITUBE: {
    id: '_PC_SPEC_DEOXYURIDINE_BITUBE',
    defaultMessage: 'U - deoxyUridine',
  },
  _PC_SPEC_BASE_B: {
    id: '_PC_SPEC_BASE_B',
    defaultMessage: 'B - Degenerate Base B',
  },
  _PC_SPEC_BASE_M: {
    id: '_PC_SPEC_BASE_M',
    defaultMessage: 'M - Degenerate Base M',
  },
  _PC_SPEC_BASE_V: {
    id: '_PC_SPEC_BASE_V',
    defaultMessage: 'V - Degenerate Base V',
  },
  _PC_SPEC_BASE_D: {
    id: '_PC_SPEC_BASE_D',
    defaultMessage: 'D - Degenerate Base D',
  },
  _PC_SPEC_BASE_N: {
    id: '_PC_SPEC_BASE_N',
    defaultMessage: 'N - Degenerate Base N',
  },
  _PC_SPEC_BASE_W: {
    id: '_PC_SPEC_BASE_W',
    defaultMessage: 'W - Degenerate Base W',
  },
  _PC_SPEC_BASE_H: {
    id: '_PC_SPEC_BASE_H',
    defaultMessage: 'H - Degenerate Base H',
  },
  _PC_SPEC_BASE_R: {
    id: '_PC_SPEC_BASE_R',
    defaultMessage: 'R - Degenerate Base R',
  },
  _PC_SPEC_BASE_Y: {
    id: '_PC_SPEC_BASE_Y',
    defaultMessage: 'Y - Degenerate Base Y',
  },
  _PC_SPEC_BASE_K: {
    id: '_PC_SPEC_BASE_K',
    defaultMessage: 'K - Degenerate Base K',
  },
  _PC_SPEC_BASE_S: {
    id: '_PC_SPEC_BASE_S',
    defaultMessage: 'S - Degenerate Base S',
  },
  _PC_SPEC_INOSINE_BITUBE: {
    id: '_PC_SPEC_INOSINE_BITUBE',
    defaultMessage: 'I - deoxyInosine',
  },
  _PC_SPEC__A: { id: '_PC_SPEC__A', defaultMessage: '[+A] - LNA Base A' },
  _PC_SPEC__C: { id: '_PC_SPEC__C', defaultMessage: '[+C] - LNA Base C' },
  _PC_SPEC__G: { id: '_PC_SPEC__G', defaultMessage: '[+G] - LNA Base G' },
  _PC_SPEC__T: { id: '_PC_SPEC__T', defaultMessage: '[+T] - LNA Base T' },
  _PC_SPEC_INT_MOD_RED_610: {
    id: '_PC_SPEC_INT_MOD_RED_610',
    defaultMessage: '[LC610] - Red 610',
  },
  _PC_SPEC_INT_MOD_RED_640: {
    id: '_PC_SPEC_INT_MOD_RED_640',
    defaultMessage: '[LC640] - Red 640',
  },
  _PC_SPEC_RED_610: { id: '_PC_SPEC_RED_610', defaultMessage: 'Red 610' },
  _PC_SPEC_RED_640: { id: '_PC_SPEC_RED_640', defaultMessage: 'Red 640' },
  _PC_SPEC_RED_670: { id: '_PC_SPEC_RED_670', defaultMessage: 'Red 670' },
  _PC_SPEC_RED_705: { id: '_PC_SPEC_RED_705', defaultMessage: 'Red 705' },
  _PC_SPEC_LCFLC: { id: '_PC_SPEC_LCFLC', defaultMessage: 'Fluorescein' },
  _PC_SPEC_0_010_mg: { id: '_PC_SPEC_0_010_mg', defaultMessage: '5x1 nmol' },
  _PC_SPEC_G95: { id: '_PC_SPEC_G95', defaultMessage: '>95%' },
  _PC_SPEC_3_OD: { id: '_PC_SPEC_3_OD', defaultMessage: '3 OD' },
  _PC_SPEC_amount_1_OD: { id: '_PC_SPEC_amount_1_OD', defaultMessage: '1 OD' },
  _PC_SPEC_amount_105_OD: {
    id: '_PC_SPEC_amount_105_OD',
    defaultMessage: '1.5 OD',
  },
  _PC_SPEC_amount_2_OD: { id: '_PC_SPEC_amount_2_OD', defaultMessage: '2 OD' },
  _PC_SPEC_amount_3_OD: { id: '_PC_SPEC_amount_3_OD', defaultMessage: '3 OD' },
  _PC_SPEC_amount_4_OD: { id: '_PC_SPEC_amount_4_OD', defaultMessage: '4 OD' },
  _PC_SPEC_amount_5_OD: { id: '_PC_SPEC_amount_5_OD', defaultMessage: '5 OD' },
  _PC_SPEC_amount_10_OD: {
    id: '_PC_SPEC_amount_10_OD',
    defaultMessage: '10 OD',
  },
  _PC_SPEC_amount_50_OD: {
    id: '_PC_SPEC_amount_50_OD',
    defaultMessage: '50 OD',
  },
  _PC_SPEC_amount_100_OD: {
    id: '_PC_SPEC_amount_100_OD',
    defaultMessage: '100 OD',
  },
  _PC_SPEC_0_1_OD: { id: '_PC_SPEC_0_1_OD', defaultMessage: '0.1 OD' },
  _PC_SPEC_0_25_OD: { id: '_PC_SPEC_D25_D', defaultMessage: '0.25 OD' },
  _PC_SPEC_1_5_OD: { id: '_PC_SPEC_1_5_OD', defaultMessage: '1.5 OD' },
  _PC_SPEC_15_OD: { id: '_PC_SPEC_15_OD', defaultMessage: '15 OD' },
  _PC_SPEC_SALT: { id: '_PC_SPEC_SALT', defaultMessage: 'Salt Exchange' },
  _PC_SPEC_ENDO: { id: '_PC_SPEC_ENDO', defaultMessage: 'Endotoxin Testing' },
  _PC_SPEC_FILTER: { id: '_PC_SPEC_FILTER', defaultMessage: 'Filtration' },
  _PC_SPEC_SERVICES: { id: '_PC_SPEC_SERVICES', defaultMessage: 'Services' },
  _PC_SPEC_PURIFICATION_iscaledna: {
    id: '_PC_SPEC_PURIFICATION_iscaledna',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_250_mg: { id: '_PC_SPEC_250_mg', defaultMessage: '250 mg' },
  _PC_SPEC_500_mg: { id: '_PC_SPEC_500_mg', defaultMessage: '500 mg' },
  _PC_SPEC_1000_mg: { id: '_PC_SPEC_1000_mg', defaultMessage: '1000 mg' },
  _PC_SPEC_2000_mg: { id: '_PC_SPEC_2000_mg', defaultMessage: '2000 mg' },
  _PC_SPEC_5000_mg: { id: '_PC_SPEC_5000_mg', defaultMessage: '5000 mg' },
  _PC_SPEC_10000_mg: { id: '_PC_SPEC_10000_mg', defaultMessage: '10000 mg' },
  _PC_SPEC_15000_mg: { id: '_PC_SPEC_15000_mg', defaultMessage: '15000 mg' },
  _PC_SPEC_Biot: {
    id: '_PC_SPEC_Biot',
    defaultMessage: '[Biot] = Biotin (no spacer)',
  },
  _PC_SPEC_Dans: { id: '_PC_SPEC_Dans', defaultMessage: '[Dans] = Dansyl' },
  _PC_SPEC_2_4_DINITROPHENYL: {
    id: '_PC_SPEC_2_4_DINITROPHENYL',
    defaultMessage: '[Dnp] =2,4-Dinitrophenyl',
  },
  _PC_SPEC_Formic_Acid: {
    id: '_PC_SPEC_Formic_Acid',
    defaultMessage: '[Form] = Formic acid',
  },
  _PC_SPEC_7_methoxycoumarin_Acetic_Acid: {
    id: '_PC_SPEC_7_methoxycoumarin_Acetic_Acid',
    defaultMessage: '[Mca] =  7-methoxycoumarin acetic acid',
  },
  _PC_SPEC_Palmitic_Acid: {
    id: '_PC_SPEC_Palmitic_Acid',
    defaultMessage: '[Palm] = Palmitic acid',
  },
  _PC_SPEC_Fluorescein: {
    id: '_PC_SPEC_Fluorescein',
    defaultMessage: '[Flc] = Fluorescein',
  },
  _PC_PROPERTY_DISPLAY_0_500mg_screen: {
    id: '_PC_PROPERTY_DISPLAY_0_500mg_screen',
    defaultMessage: '0.5 mg',
  },
  _PC_PROPERTY_DISPLAY_2_000mg_screen: {
    id: '_PC_PROPERTY_DISPLAY_2_000mg_screen',
    defaultMessage: '2 mg',
  },
  _PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen: {
    id: '_PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen',
    defaultMessage:
      ' Minimum guaranteed amount is based on 0.5 mg or 2 mg option.',
  },
  _PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen_remaining: {
    id: '_PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen_remaining',
    defaultMessage:
      ' The amount of individual peptides will vary in the set due to different peptide lengths and compositions.',
  },
  _PC_PROPERTY_DISPLAY_Desalt_screen: {
    id: '_PC_PROPERTY_DISPLAY_Desalt_screen',
    defaultMessage: 'Desalted',
  },
  _PC_TOR_PEPTIDE_FORMAT_TOOLTIP_screen: {
    id: '_PC_TOR_PEPTIDE_FORMAT_TOOLTIP_screen',
    defaultMessage: ' Dry = Lyophilized; In Solution = 20 mg/mL in DMSO',
  },
  _PC_PROPERTY_DISPLAY_DRY_screen: {
    id: '_PC_PROPERTY_DISPLAY_DRY_screen',
    defaultMessage: 'Dry',
  },
  _PC_PROPERTY_DISPLAY_INSOL_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_screen',
    defaultMessage: 'In Solution (20mg/ml in DMSO)',
  },
  _PC_PROPERTY_DISPLAY_INSOL_40_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_40_screen',
    defaultMessage: 'In Solution (40mg/ml in DMSO)',
  },
  _PC_PROPERTY_DISPLAY_YES_screen: {
    id: '_PC_PROPERTY_DISPLAY_YES_screen',
    defaultMessage: 'Yes',
  },
  _PC_PROPERTY_DISPLAY_NO_screen: {
    id: '_PC_PROPERTY_DISPLAY_NO_screen',
    defaultMessage: 'No',
  },
  _PC_REVIEW_PURITY_PROFILE_YES_screen: {
    id: '_PC_REVIEW_PURITY_PROFILE_YES_screen',
    defaultMessage: 'Yes',
  },
  _PC_REVIEW_PURITY_PROFILE_NO_screen: {
    id: '_PC_REVIEW_PURITY_PROFILE_NO_screen',
    defaultMessage: 'No',
  },
  _PC_SH_PRODUCT_NAME_longoligo: {
    id: '_PC_SH_PRODUCT_NAME_longoligo',
    defaultMessage: 'Long Oligos',
  },
  _PC_SPEC_PURIFICATION: {
    id: '_PC_SPEC_PURIFICATION',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_dUracil: { id: '_PC_SPEC_dUracil', defaultMessage: 'Uracil' },
  _PC_SPEC_JOE: { id: '_PC_SPEC_JOE', defaultMessage: 'JOE' },
  _PC_SPEC_ROX: { id: '_PC_SPEC_ROX', defaultMessage: 'ROX' },
  _PC_SPEC_TAMRA: { id: '_PC_SPEC_TAMRA', defaultMessage: 'TAMRA' },
  _PC_SPEC_Texas_Red: { id: '_PC_SPEC_Texas_Red', defaultMessage: 'TxRd' },
  _PC_SPEC_5_FAMTM: { id: '_PC_SPEC_5_FAMTM', defaultMessage: '5-FAM' },
  _PC_SPEC_Alexa_Fluor_488: {
    id: '_PC_SPEC_Alexa_Fluor_488',
    defaultMessage: 'Sulfonated Fluorescein 488',
  },
  _PC_SPEC_ATTO488: { id: '_PC_SPEC_ATTO488', defaultMessage: 'ATTO 488' },
  _PC_SPEC_ATTO532: { id: '_PC_SPEC_ATTO532', defaultMessage: 'ATTO 532' },
  _PC_SPEC_ATTO550: { id: '_PC_SPEC_ATTO550', defaultMessage: 'ATTO 550' },
  _PC_SPEC_ATTO565: { id: '_PC_SPEC_ATTO565', defaultMessage: 'ATTO 565' },
  _PC_SPEC_ATTO647N: { id: '_PC_SPEC_ATTO647N', defaultMessage: 'ATTO 647N' },
  _PC_SPEC_ATTO680: { id: '_PC_SPEC_ATTO680', defaultMessage: 'ATTO 680' },
  _PC_SPEC_DIGOXIGENIN: {
    id: '_PC_SPEC_DIGOXIGENIN',
    defaultMessage: 'Digoxigenin',
  },
  _PC_SPEC_Oregon_Green_488: {
    id: '_PC_SPEC_Oregon_Green_488',
    defaultMessage: 'Oregon Green 488',
  },
  _PC_SPEC_Oregon_Green_488_X: {
    id: '_PC_SPEC_Oregon_Green_488_X',
    defaultMessage: 'Oregon Green 488-X',
  },
  _PC_SPEC_Oregon_Green_514: {
    id: '_PC_SPEC_Oregon_Green_514',
    defaultMessage: 'Oregon Green 514',
  },
  _PC_SPEC_Pacific_Blue: {
    id: '_PC_SPEC_Pacific_Blue',
    defaultMessage: 'Pacific Blue',
  },
  _PC_SPEC_6_Carboxy_rhodamine: {
    id: '_PC_SPEC_6_Carboxy_rhodamine',
    defaultMessage: '6-Carboxy-rhodamine 6G',
  },
  _PC_SPEC_Rhodamine_RedTM_X: {
    id: '_PC_SPEC_Rhodamine_RedTM_X',
    defaultMessage: 'Rhodamine RedTM-X',
  },
  _PC_SPEC_Derivative_K_dK: {
    id: '_PC_SPEC_Derivative_K_dK',
    defaultMessage: 'Derivative K (dK)',
  },
  _PC_SPEC_Derivative_P_dP: {
    id: '_PC_SPEC_Derivative_P_dP',
    defaultMessage: 'Derivative P (dK)',
  },
  _PC_SPEC_Thymidine_Glycol: {
    id: '_PC_SPEC_Thymidine_Glycol',
    defaultMessage: 'Thymidine Glycol',
  },
  _PC_SPEC_Spacer_9: { id: '_PC_SPEC_Spacer_9', defaultMessage: 'Spacer 9' },
  _PC_SPEC_Spacer_18: { id: '_PC_SPEC_Spacer_18', defaultMessage: 'Spacer 18' },
  _PC_SPEC_Spacer_12: { id: '_PC_SPEC_Spacer_12', defaultMessage: 'Spacer 12' },
  _PC_SPEC_Spacer_C3: { id: '_PC_SPEC_Spacer_C3', defaultMessage: 'Spacer C3' },
  _PC_SPEC_8_Br_dA: { id: '_PC_SPEC_8_Br_dA', defaultMessage: '8-Br-dA' },
  _PC_SPEC_8_Br_dG: { id: '_PC_SPEC_8_Br_dG', defaultMessage: '8-Br-dG' },
  _PC_SPEC_5_Br_dC: { id: '_PC_SPEC_5_Br_dC', defaultMessage: '5-Br-dC' },
  _PC_SPEC_5_Br_dU: { id: '_PC_SPEC_5_Br_dU', defaultMessage: '5-Br-dU' },
  _PC_SPEC_5_Nitroindole: {
    id: '_PC_SPEC_5_Nitroindole',
    defaultMessage: '5-Nitroindole',
  },
  _PC_SPEC_5_Me_dC: { id: '_PC_SPEC_5_Me_dC', defaultMessage: '5-Me-dC' },
  _PC_SPEC_Cytosine_Arabinoside_araC: {
    id: '_PC_SPEC_Cytosine_Arabinoside_araC',
    defaultMessage: 'Cytosine Arabinoside (araC)',
  },
  _PC_SPEC_8_Oxo_dA: { id: '_PC_SPEC_8_Oxo_dA', defaultMessage: '8-oxo-dA' },
  _PC_SPEC_8_Oxo_dG: { id: '_PC_SPEC_8_Oxo_dG', defaultMessage: '8-oxo-dG' },
  _PC_SPEC_2_6_Diaminopurine: {
    id: '_PC_SPEC_2_6_Diaminopurine',
    defaultMessage: '2,6-Diaminopurine',
  },
  _PC_SPEC_2_Aminopurine: {
    id: '_PC_SPEC_2_Aminopurine',
    defaultMessage: '2-Aminopurine',
  },
  _PC_SPEC_dA_5_Inverse_Oligo: {
    id: '_PC_SPEC_dA_5_Inverse_Oligo',
    defaultMessage: "dA-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dG_5_Inverse_Oligo: {
    id: '_PC_SPEC_dG_5_Inverse_Oligo',
    defaultMessage: "dG-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dC_5_Inverse_Oligo: {
    id: '_PC_SPEC_dC_5_Inverse_Oligo',
    defaultMessage: "dC-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dSpacer: { id: '_PC_SPEC_dSpacer', defaultMessage: 'dSpacer' },
  _PC_SPEC_dT_5_Inverse_Oligo: {
    id: '_PC_SPEC_dT_5_Inverse_Oligo',
    defaultMessage: "dT-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_URIDINE: { id: '_PC_SPEC_URIDINE', defaultMessage: 'Uracil' },
  _PC_SPEC_Cholesteryl_TEG: {
    id: '_PC_SPEC_Cholesteryl_TEG',
    defaultMessage: 'Cholesteryl TEG',
  },
  _PC_SPEC_2_OMe_RNA_A: {
    id: '_PC_SPEC_2_OMe_RNA_A',
    defaultMessage: "2'-OMe-RNA A",
  },
  _PC_SPEC_2_OMe_RNA_G: {
    id: '_PC_SPEC_2_OMe_RNA_G',
    defaultMessage: "2'-OMe-RNA G",
  },
  _PC_SPEC_2_OMe_RNA_C: {
    id: '_PC_SPEC_2_OMe_RNA_C',
    defaultMessage: "2'-OMe-RNA C",
  },
  _PC_SPEC_2_OMe_RNA_U: {
    id: '_PC_SPEC_2_OMe_RNA_U',
    defaultMessage: "2'-OMe-RNA U",
  },
  _PC_SPEC_Thiophosphate_S_Oligo: {
    id: '_PC_SPEC_Thiophosphate_S_Oligo',
    defaultMessage: 'Thiophosphate',
  },
  _PC_SPEC_Alexa_Fluor_546: {
    id: '_PC_SPEC_Alexa_Fluor_546',
    defaultMessage: 'Alexa Fluor 546',
  },
  _PC_SPEC_Alexa_Fluor_647: {
    id: '_PC_SPEC_Alexa_Fluor_647',
    defaultMessage: 'Alexa Fluor 647',
  },
  _PC_SPEC_Dabcyl: { id: '_PC_SPEC_Dabcyl', defaultMessage: 'Dabcyl' },
  _PC_SPEC_ONXY_A: { id: '_PC_SPEC_ONXY_A', defaultMessage: 'Onyx Quencher A' },
  _PC_SPEC_ONXY_B: { id: '_PC_SPEC_ONXY_B', defaultMessage: 'Onyx Quencher B' },
  _PC_SPEC_ONXY_C: { id: '_PC_SPEC_ONXY_C', defaultMessage: 'Onyx Quencher C' },
  _PC_SPEC_ONXY_D: { id: '_PC_SPEC_ONXY_D', defaultMessage: 'Onyx Quencher D' },
  _PC_SPEC_3_Amino_Modifier_C3: {
    id: '_PC_SPEC_3_Amino_Modifier_C3',
    defaultMessage: 'Amino-Modifier C3',
  },
  _PC_SPEC_Thiol_Modifier_C3_S_S: {
    id: '_PC_SPEC_Thiol_Modifier_C3_S_S',
    defaultMessage: 'Thiol-Modifier C3 S-S',
  },
  _PC_SPEC_3_dA: {
    id: '_PC_SPEC_3_dA',
    defaultMessage: "3'-dA (chain terminator)",
  },
  _PC_SPEC_3_dG: {
    id: '_PC_SPEC_3_dG',
    defaultMessage: "3'-dG (chain terminator)",
  },
  _PC_SPEC_3_dC: {
    id: '_PC_SPEC_3_dC',
    defaultMessage: "3'-dC (chain terminator)",
  },
  _PC_SPEC_3_dT: {
    id: '_PC_SPEC_3_dT',
    defaultMessage: "3'-dT (chain terminator)",
  },
  _PC_SPEC_FluoresceindT: {
    id: '_PC_SPEC_FluoresceindT',
    defaultMessage: 'Fluorescein dT',
  },
  _PC_SPEC_Amino_Modifier_C2_dT: {
    id: '_PC_SPEC_Amino_Modifier_C2_dT',
    defaultMessage: 'Amino-Modifier C2 dT',
  },
  _PC_SPEC_Amino_Modifier_C6_dT: {
    id: '_PC_SPEC_Amino_Modifier_C6_dT',
    defaultMessage: 'Amino-Modifier C6 dT',
  },
  _PC_SPEC_BIOTIN_DT: { id: '_PC_SPEC_BIOTIN_DT', defaultMessage: 'Biotin dT' },
  _PC_SPEC_2_3_dideoxycytidine_ddC: {
    id: '_PC_SPEC_2_3_dideoxycytidine_ddC',
    defaultMessage: "2',3'-ddC",
  },
  _PC_SPEC_Inosine: { id: '_PC_SPEC_Inosine', defaultMessage: 'Inosine' },
  _PC_SPEC_5BrdC: { id: '_PC_SPEC_5BrdC', defaultMessage: '5-Br-dC' },
  _PC_SPEC_5BrDU: { id: '_PC_SPEC_5BrDU', defaultMessage: '5-Br-dU' },
  _PC_SPEC_FIVEMOD_SPECIAL: {
    id: '_PC_SPEC_FIVEMOD_SPECIAL',
    defaultMessage: 'Special',
  },
  _PC_SPEC_INTERNALMOD_SPECIAL: {
    id: '_PC_SPEC_INTERNALMOD_SPECIAL',
    defaultMessage: 'Special',
  },
  _PC_SPEC_BHQ1: { id: '_PC_SPEC_BHQ1', defaultMessage: 'BHQ1' },
  _PC_SPEC_BHQ2: { id: '_PC_SPEC_BHQ2', defaultMessage: 'BHQ2' },
  _PC_SPEC_BHQ3: { id: '_PC_SPEC_BHQ3', defaultMessage: 'BHQ3' },
  _PC_SPEC_DABDT: { id: '_PC_SPEC_DABDT', defaultMessage: 'Dabcyl' },
  _PC_SPEC_FLUORESCENT: {
    id: '_PC_SPEC_FLUORESCENT',
    defaultMessage: 'Fluorescent',
  },
  _PC_SPEC_ATTACHMENT: {
    id: '_PC_SPEC_ATTACHMENT',
    defaultMessage: 'Attachment',
  },
  _PC_SPEC_BINDING: { id: '_PC_SPEC_BINDING', defaultMessage: 'Binding' },
  _PC_SPEC_SPACER: { id: '_PC_SPEC_SPACER', defaultMessage: 'Spacer' },
  _PC_SPEC_ANALOG: { id: '_PC_SPEC_ANALOG', defaultMessage: 'Analog' },
  _PC_SPEC_ANTISENSE: { id: '_PC_SPEC_ANTISENSE', defaultMessage: 'Antisense' },
  _PC_SPEC_wellred: { id: '_PC_SPEC_wellred', defaultMessage: 'WellRED' },
  _PC_SPEC_VIEWALL_PURITY_LEVEL: {
    id: '_PC_SPEC_VIEWALL_PURITY_LEVEL',
    defaultMessage: 'Purity Level :',
  },
  _PC_SPEC_15_000_mg: { id: 'PC_SPEC_15_000_mg', defaultMessage: '15 mg' },
  _PC_SPEC_2_0NM: { id: '_PC_SPEC_2_0NM', defaultMessage: '2 nmol' },
  _PC_SPEC_5_0NM: { id: '_PC_SPEC_5_0NM', defaultMessage: '5 nmol' },
  _PC_SPEC_YES: { id: '_PC_SPEC_YES', defaultMessage: 'Yes' },
  _PC_SPEC_NO: { id: '_PC_SPEC_NO', defaultMessage: 'No' },
  _PC_SPEC_CUSTOM_CRISPR_N: {
    id: '_PC_SPEC_CUSTOM_CRISPR_N',
    defaultMessage: 'No',
  },
  _PC_SPEC_CUSTOM_CRISPR_Y: {
    id: '_PC_SPEC_CUSTOM_CRISPR_Y',
    defaultMessage: 'Yes',
  },
  _PC_SPEC_3_0NM: { id: '_PC_SPEC_3_0NM', defaultMessage: '3 nmol' },
  _PC_SPEC_antisera: {
    id: '_PC_SPEC_antisera',
    defaultMessage: 'Specifications',
  },
  _PC_PEP_NAME_NOTE_antisera: {
    id: '_PC_PEP_NAME_NOTE_antisera',
    defaultMessage:
      'Character limit is 20 including spaces. Do not use ASCII characters.',
  },
  _PC_N_TERMMOD_antisera: {
    id: '_PC_N_TERMMOD_antisera',
    defaultMessage: 'N-Terminal Modification',
  },
  _PC_PEP_SEQ_antisera: {
    id: '_PC_PEP_SEQ_antisera',
    defaultMessage: 'Sequence (N to C)',
  },
  _PC_PEP_AMINOACID_antisera: {
    id: '_PC_PEP_AMINOACID_antisera',
    defaultMessage: '# Amino Acids: ',
  },
  _PC_carrierProtein: {
    id: '_PC_carrierProtein',
    defaultMessage: 'Carrier Protein',
  },
  _PC_ADDSPEC_antisera: {
    id: '_PC_ADDSPEC_antisera',
    defaultMessage: 'Additional Specifications',
  },
  _PC_PEP_ADD_INTMOD_antisera: {
    id: '_PC_PEP_ADD_INTMOD_antisera',
    defaultMessage: 'Add Internal Modification',
  },
  _PC_PEP_CTERM_MOD_antisera: {
    id: '_PC_PEP_CTERM_MOD_antisera',
    defaultMessage: 'C-Terminal Modification',
  },
  _PC_PEP_AMINOACID_simpleantisera: {
    id: '_PC_PEP_AMINOACID_simpleantisera',
    defaultMessage: '# Amino Acid',
  },
  _PC_PROJECT_TYPE_antisera: {
    id: '_PC_PROJECT_TYPE_antisera',
    defaultMessage: 'Project Type',
  },
  _PC_PEP_CTERM_MOD_simpleantisera: {
    id: '_PC_PEP_CTERM_MOD_simpleantisera',
    defaultMessage: 'C-Terminal Modification',
  },
  _PC_PEP_NTERM_MOD_simpleantisera: {
    id: '_PC_PEP_NTERM_MOD_simpleantisera',
    defaultMessage: 'N-Terminal Modification',
  },
  _PC_SH_MAIN_HEADER_ANTISERA: {
    id: '_PC_SH_MAIN_HEADER_ANTISERA',
    defaultMessage: 'Antisera',
  },
  _PC_SH_MAIN_HEADER_SIMPLE_ANTISERA: {
    id: '_PC_SH_MAIN_HEADER_SIMPLE_ANTISERA',
    defaultMessage: 'Simple Antisera',
  },
  _PC_SPEC_FORMAT_TE: {
    id: '_PC_SPEC_FORMAT_TE',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_SIRNA_TITLE: {
    id: '_PC_SIRNA_TITLE',
    defaultMessage: 'Custom siRNA in Tubes',
  },
  _PC_SPEC_UG: { id: '_PC_SPEC_UG', defaultMessage: 'UG' },
  _PC_SPEC_UC: { id: '_PC_SPEC_UC', defaultMessage: 'UC' },
  _PC_SPEC_UA: { id: '_PC_SPEC_UA', defaultMessage: 'UA' },
  _PC_SPEC_GU: { id: '_PC_SPEC_GU', defaultMessage: 'GU' },
  _PC_SPEC_GG: { id: '_PC_SPEC_GG', defaultMessage: 'GG' },
  _PC_SPEC_GC: { id: '_PC_SPEC_GC', defaultMessage: 'GC' },
  _PC_SPEC_GA: { id: '_PC_SPEC_GA', defaultMessage: 'GA' },
  _PC_SPEC_CU: { id: '_PC_SPEC_CU', defaultMessage: 'CU' },
  _PC_SPEC_CG: { id: '_PC_SPEC_CG', defaultMessage: 'CG' },
  _PC_SPEC_CC: { id: '_PC_SPEC_CC', defaultMessage: 'CC' },
  _PC_SPEC_CA: { id: '_PC_SPEC_CA', defaultMessage: 'CA' },
  _PC_SPEC_AU: { id: '_PC_SPEC_AU', defaultMessage: 'AU' },
  _PC_SPEC_AG: { id: '_PC_SPEC_AG', defaultMessage: 'AG' },
  _PC_SPEC_AC: { id: '_PC_SPEC_AC', defaultMessage: 'AC' },
  _PC_SPEC_AA: { id: '_PC_SPEC_AA', defaultMessage: 'AA' },
  _PC_SPEC_MODIFIES_RNA_SCALE: {
    id: '_PC_SPEC_MODIFIES_RNA_SCALE',
    defaultMessage:
      '* Guarantee is for oligos 20 bases or longer, shorter oligos may have fewer ODs. Microgram amounts are calculated based on a 30 µg/OD value. If the µg/OD value is less than 30, the reported µg value will be proportionally less. Post-synthesis modifications may yield 50% less than the above stated values.',
  },
  _PC_SPEC_0_050_UMO: {
    id: '_PC_SPEC_0_050_UMO',
    defaultMessage: '0.05 µmole',
  },
  _PC_SPEC_0_025_UMO: {
    id: '_PC_SPEC_0_025_UMO',
    defaultMessage: '0.025 µmole',
  },
  _PC_SPEC_0_200_UMO: { id: '_PC_SPEC_0_200_UMO', defaultMessage: '0.2 µmole' },
  _PC_SPEC_1_000_UMO: { id: '_PC_SPEC_1_000_UMO', defaultMessage: '1 µmole' },
  _PC_SPEC_10_000_UMO: {
    id: '_PC_SPEC_10_000_UMO',
    defaultMessage: '10 µmole',
  },
  _PC_SPEC_15_000_UMO: {
    id: '_PC_SPEC_15_000_UMO',
    defaultMessage: '15 µmole',
  },
  _PC_SPEC_IS_WATER_RNA: {
    id: '_PC_SPEC_IS_WATER_RNA',
    defaultMessage: 'In Solution (TE)',
  },
  PC_SPEC_EC_AMINO_LINKER: {
    id: 'PC_SPEC_EC_AMINO_LINKER',
    defaultMessage: 'EC Amino Linker',
  },
  PC_SPEC_LOADING: { id: '_PC_SPEC_LOADING', defaultMessage: 'Loading....' },
  PC_SPEC_IN_SOLUTION: {
    id: 'PC_SPEC_IN_SOLUTION',
    defaultMessage: 'In Solution',
  },
  PC_SPEC_1_duplexplate: {
    id: 'PC_SPEC_1_duplexplate',
    defaultMessage: '1 nmol (0.2 OD)',
  },
  PC_SPEC_2_duplexplate: {
    id: 'PC_SPEC_2_duplexplate',
    defaultMessage: '2 nmol (0.4 OD)',
  },
  PC_SPEC_10_duplexplate: {
    id: 'PC_SPEC_10_duplexplate',
    defaultMessage: '10 nmol (2 OD)',
  },
  PC_SPEC_DRY_duplexplate: {
    id: 'PC_SPEC_DRY_duplexplate',
    defaultMessage: 'Dry',
  },
  PC_SPEC_DESALT_duplexplate: {
    id: 'PC_SPEC_DESALT_duplexplate',
    defaultMessage: 'Desalt',
  },
  PC_SPEC_RP1_duplexplate: {
    id: 'PC_SPEC_RP1_duplexplate',
    defaultMessage: 'Cartridge',
  },
  PC_SPEC_HPLC_duplexplate: {
    id: 'PC_SPEC_HPLC_duplexplate',
    defaultMessage: 'HPLC',
  },
  PC_SPEC_AmC6_duplexplate: {
    id: 'PC_SPEC_AmC6_duplexplate',
    defaultMessage: 'Amino-Modifier C6',
  },
  PC_SPEC_Btn_duplexplate: {
    id: 'PC_SPEC_Btn_duplexplate',
    defaultMessage: 'Biotin',
  },
  PC_SPEC_Cyanine3_duplexplate: {
    id: 'PC_SPEC_Cyanine3_duplexplate',
    defaultMessage: 'Cyanine 3',
  },
  PC_SPEC_Cyanine5_duplexplate: {
    id: 'PC_SPEC_Cyanine5_duplexplate',
    defaultMessage: 'Cyanine 5',
  },
  PC_SPEC_Cyanine55_duplexplate: {
    id: 'PC_SPEC_Cyanine55_duplexplate',
    defaultMessage: 'Cyanine 5.5',
  },
  PC_SPEC_6FAM_duplexplate: {
    id: 'PC_SPEC_6FAM_duplexplate',
    defaultMessage: '6-FAM  (fluorescein)',
  },
  PC_SPEC_Phos_duplexplate: {
    id: 'PC_SPEC_Phos_duplexplate',
    defaultMessage: 'Phosphate',
  },
  PC_SPEC_Flc_duplexplate: {
    id: 'PC_SPEC_Flc_duplexplate',
    defaultMessage: 'Fluorescein',
  },
  PC_SPEC_None_duplexplate: {
    id: 'PC_SPEC_None_duplexplate',
    defaultMessage: 'None',
  },
  PC_SPEC_ThiC6_duplexplate: {
    id: 'PC_SPEC_ThiC6_duplexplate',
    defaultMessage: 'Thiol-Modifier-C6 S-S',
  },
  PC_SPEC_InvAb_duplexplate: {
    id: 'PC_SPEC_InvAb_duplexplate',
    defaultMessage: 'Inverted Abasic',
  },
  PC_SPEC_AmC7_duplexplate: {
    id: 'PC_SPEC_AmC7_duplexplate',
    defaultMessage: 'Amino-Modifier C7',
  },
  PC_SPEC_dT5F_duplexplate: {
    id: 'PC_SPEC_dT5F_duplexplate',
    defaultMessage: 'Flipped Base',
  },
  PC_SPEC_dTdT_duplexplate: {
    id: 'PC_SPEC_dTdT_duplexplate',
    defaultMessage: '[dT][dT]',
  },
  PC_SPEC_dTdG_duplexplate: {
    id: 'PC_SPEC_dTdG_duplexplate',
    defaultMessage: '[dT][dG]',
  },
  PC_SPEC_dTdC_duplexplate: {
    id: 'PC_SPEC_dTdC_duplexplate',
    defaultMessage: '[dT][dC]',
  },
  PC_SPEC_dTdA_duplexplate: {
    id: 'PC_SPEC_dTdA_duplexplate',
    defaultMessage: '[dT][dA]',
  },
  PC_SPEC_dGdT_duplexplate: {
    id: 'PC_SPEC_dGdT_duplexplate',
    defaultMessage: '[dG][dT]',
  },
  PC_SPEC_dGdG_duplexplate: {
    id: 'PC_SPEC_dGdG_duplexplate',
    defaultMessage: '[dG][dG]',
  },
  PC_SPEC_dGdC_duplexplate: {
    id: 'PC_SPEC_dGdC_duplexplate',
    defaultMessage: '[dG][dC]',
  },
  PC_SPEC_dGdA_duplexplate: {
    id: 'PC_SPEC_dGdA_duplexplate',
    defaultMessage: '[dG][dA]',
  },
  PC_SPEC_dCdT_duplexplate: {
    id: 'PC_SPEC_dCdT_duplexplate',
    defaultMessage: '[dC][dT]',
  },
  PC_SPEC_dCdG_duplexplate: {
    id: 'PC_SPEC_dCdG_duplexplate',
    defaultMessage: '[dC][dG]',
  },
  PC_SPEC_dAdA_duplexplate: {
    id: 'PC_SPEC_dAdA_duplexplate',
    defaultMessage: '[dA][dA]',
  },
  PC_SPEC_UU_duplexplate: {
    id: 'PC_SPEC_UU_duplexplate',
    defaultMessage: 'UU',
  },
  PC_SPEC_UG_duplexplate: {
    id: 'PC_SPEC_UG_duplexplate',
    defaultMessage: 'UG',
  },
  PC_SPEC_UC_duplexplate: {
    id: 'PC_SPEC_UC_duplexplate',
    defaultMessage: 'UC',
  },
  PC_SPEC_UA_duplexplate: {
    id: 'PC_SPEC_UA_duplexplate',
    defaultMessage: 'UA',
  },
  PC_SPEC_GU_duplexplate: {
    id: 'PC_SPEC_GU_duplexplate',
    defaultMessage: 'GU',
  },
  PC_SPEC_GG_duplexplate: {
    id: 'PC_SPEC_GG_duplexplate',
    defaultMessage: 'GG',
  },
  PC_SPEC_GC_duplexplate: {
    id: 'PC_SPEC_GC_duplexplate',
    defaultMessage: 'GC',
  },
  PC_SPEC_GA_duplexplate: {
    id: 'PC_SPEC_GA_duplexplate',
    defaultMessage: 'GA',
  },
  PC_SPEC_CU_duplexplate: {
    id: 'PC_SPEC_CU_duplexplate',
    defaultMessage: 'CU',
  },
  PC_SPEC_CG_duplexplate: {
    id: 'PC_SPEC_CG_duplexplate',
    defaultMessage: 'CG',
  },
  PC_SPEC_CC_duplexplate: {
    id: 'PC_SPEC_CC_duplexplate',
    defaultMessage: 'CC',
  },
  PC_SPEC_CA_duplexplate: {
    id: 'PC_SPEC_CA_duplexplate',
    defaultMessage: 'CA',
  },
  PC_SPEC_AU_duplexplate: {
    id: 'PC_SPEC_AU_duplexplate',
    defaultMessage: 'AU',
  },
  PC_SPEC_AG_duplexplate: {
    id: 'PC_SPEC_AG_duplexplate',
    defaultMessage: 'AG',
  },
  PC_SPEC_AC_duplexplate: {
    id: 'PC_SPEC_AC_duplexplate',
    defaultMessage: 'AC',
  },
  PC_SPEC_AA_duplexplate: {
    id: 'PC_SPEC_AA_duplexplate',
    defaultMessage: 'AA',
  },
  PC_SPEC_dCdC_duplexplate: {
    id: 'PC_SPEC_dCdC_duplexplate',
    defaultMessage: '[dC][dC]',
  },
  PC_SPEC_dCdA_duplexplate: {
    id: 'PC_SPEC_dCdA_duplexplate',
    defaultMessage: '[dC][dA]',
  },
  PC_SPEC_dAdT_duplexplate: {
    id: 'PC_SPEC_dAdT_duplexplate',
    defaultMessage: '[dA][dT]',
  },
  PC_SPEC_dAdG_duplexplate: {
    id: 'PC_SPEC_dAdG_duplexplate',
    defaultMessage: '[dA][dG]',
  },
  PC_SPEC_dAdC_duplexplate: {
    id: 'PC_SPEC_dAdC_duplexplate',
    defaultMessage: '[dA][dC]',
  },
  PC_SPEC_SPECIES_Chicken_milliplex: {
    id: 'PC_SPEC_SPECIES_Chicken_milliplex',
    defaultMessage: 'Chicken',
  },
  PC_SPEC_CONJUGATION_AMOUNT: {
    id: 'PC_SPEC_CONJUGATION_AMOUNT',
    defaultMessage: 'Conjugation Amount',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN',
    defaultMessage: 'Additional Carrier Protein',
  },
  PC_SPEC_6_FAM_DESC: {
    id: 'PC_SPEC_6_FAM_DESC',
    defaultMessage: '[6FAM] = Fluorescein',
  },
  PC_SPEC_TAM_DESC: { id: 'PC_SPEC_TAM_DESC', defaultMessage: '[TAM] = TAMRA' },
  PC_SPEC_PEG: { id: 'PC_SPEC_PEG', defaultMessage: '[PEG] = Pegylation' },
  PC_SPEC_FITC: {
    id: 'PC_SPEC_FITC',
    defaultMessage: '[FITC] = Fluorescein-5isothiocyanate',
  },
  PC_SPEC_ACA: { id: 'PC_SPEC_ACA', defaultMessage: '[ACA]' },
  PC_SPEC_KBTN: { id: 'PC_SPEC_KBTN', defaultMessage: '[K_Btn]' },
  PC_SPEC_CYCL: {
    id: 'PC_SPEC_CYCL',
    defaultMessage: '[Cycl] = Disulfide Bond Formation',
  },
  PC_SPEC_PSER: { id: 'PC_SPEC_PSER', defaultMessage: '[pSer]=Phosphoserine' },
  PC_SPEC_PTHR: {
    id: 'PC_SPEC_PTHR',
    defaultMessage: '[pThr]=Phosphotheronine',
  },
  PC_SPEC_PTYR: {
    id: 'PC_SPEC_PTYR',
    defaultMessage: '[pTyr]=Phosphotyrosine',
  },
  PC_SPEC_2_mg: { id: 'PC_SPEC_2_mg', defaultMessage: '2 mg' },
  PC_SPEC_3_mg: { id: 'PC_SPEC_3_mg', defaultMessage: '3 mg' },
  PC_SPEC_5_mg: { id: 'PC_SPEC_5_mg', defaultMessage: '5 mg' },
  PC_SPEC_15_mg: { id: 'PC_SPEC_15_mg', defaultMessage: '15 mg' },
  PC_SPEC_IMMUNO: {
    id: 'PC_SPEC_IMMUNO',
    defaultMessage: 'Immunological Grade',
  },
  PC_SPEC_G50: { id: 'PC_SPEC_G50', defaultMessage: '>50%' },
  PC_SPEC_Unpurified: {
    id: 'PC_SPEC_Unpurified',
    defaultMessage: 'Unpurified',
  },
  PC_SPEC_G70: { id: 'PC_SPEC_G70', defaultMessage: '>70%' },
  PC_SPEC_G80: { id: 'PC_SPEC_G80', defaultMessage: '>80%' },
  PC_SPEC_G90: { id: 'PC_SPEC_G90', defaultMessage: '>90%' },
  PC_SPEC_G95: { id: 'PC_SPEC_G95', defaultMessage: '>95%' },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_KLH: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_KLH',
    defaultMessage: 'KLH',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_BSA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_BSA',
    defaultMessage: 'BSA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_OVA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_OVA',
    defaultMessage: 'OVA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_RSA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_RSA',
    defaultMessage: 'RSA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_NONE: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_NONE',
    defaultMessage: 'None',
  },
  PC_SPEC_1: { id: 'PC_SPEC_1', defaultMessage: '1' },
  PC_SPEC_2: { id: 'PC_SPEC_2', defaultMessage: '2' },
  PC_SPEC_3: { id: 'PC_SPEC_3', defaultMessage: '3' },
  PC_SPEC_4: { id: 'PC_SPEC_4', defaultMessage: '4' },
  PC_SPEC_5: { id: 'PC_SPEC_5', defaultMessage: '5' },
  PC_SPEC_6: { id: 'PC_SPEC_6', defaultMessage: '6' },
  PC_SPEC_7: { id: 'PC_SPEC_7', defaultMessage: '7' },
  PC_SPEC_8: { id: 'PC_SPEC_8', defaultMessage: '8' },
  PC_SPEC_9: { id: 'PC_SPEC_9', defaultMessage: '9' },
  PC_SPEC_10: { id: 'PC_SPEC_10', defaultMessage: '10' },
  PC_SPEC_SALT: {
    id: 'PC_SPEC_SALT',
    defaultMessage:
      'Salt Exchange - Sodium salt exchange performed at the end of the process',
  },
  PC_SPEC_ENDO: {
    id: 'PC_SPEC_ENDO',
    defaultMessage:
      'Endotoxin Testing - Performed on a sample of the product and can be requested for In Vivo treated oligos',
  },
  PC_SPEC_FILTER: {
    id: 'PC_SPEC_FILTER',
    defaultMessage:
      'Filtration - Final product filtered through a 0.2µm filter',
  },
  PC_SPEC_HPLC: { id: 'PC_SPEC_HPLC', defaultMessage: 'HPLC' },
  PC_SPEC_VIVO: { id: 'PC_SPEC_VIVO', defaultMessage: 'In Vivo Treatment' },
  PC_SPEC_CATRIDGE_longoligo: {
    id: 'PC_SPEC_CATRIDGE_longoligo',
    defaultMessage: 'Cartridge (Yield: 5 OD)',
  },
  PC_SPEC_PAGE_longoligo: {
    id: 'PC_SPEC_PAGE_longoligo',
    defaultMessage: 'PAGE (Yield: 0.5 OD)',
  },
  PC_SPEC_05_D: { id: 'PC_SPEC_05_D', defaultMessage: '0.5 OD' },
  PC_SPEC_5_OD: { id: 'PC_SPEC_5_OD', defaultMessage: '5 OD' },
  PC_SPEC_0_5_OD: { id: 'PC_SPEC_0_5_OD', defaultMessage: '0.5 OD' },
  PC_SPEC_GRAYEDOUT_WARNING_milliplex: {
    id: 'PC_SPEC_GRAYEDOUT_WARNING_milliplex',
    defaultMessage:
      'Greyed out analytes cannot be plexed with your selected analyte',
  },
  PC_SPEC_MINIPEG: {
    id: 'PC_SPEC_MINIPEG',
    defaultMessage: '[mini-PEG] = mini-Pegylation',
  },
  PC_SPEC_SPECIES_Canine_milliplex: {
    id: 'PC_SPEC_SPECIES_Canine_milliplex',
    defaultMessage: 'Canine',
  },
  PC_SPEC_SPECIES_Bovine_milliplex: {
    id: 'PC_SPEC_SPECIES_Bovine_milliplex',
    defaultMessage: 'Bovine',
  },
  PC_SPEC_SPECIES_Equine_milliplex: {
    id: 'PC_SPEC_SPECIES_Equine_milliplex',
    defaultMessage: 'Equine',
  },
  PC_SPEC_SPECIES_Feline_milliplex: {
    id: 'PC_SPEC_SPECIES_Feline_milliplex',
    defaultMessage: 'Feline',
  },
  PC_SPEC_SPECIES_Human_milliplex: {
    id: 'PC_SPEC_SPECIES_Human_milliplex',
    defaultMessage: 'Human',
  },
  PC_SPEC_SPECIES_Mouse_milliplex: {
    id: 'PC_SPEC_SPECIES_Mouse_milliplex',
    defaultMessage: 'Mouse',
  },
  PC_SPEC_SPECIES_Porcine_milliplex: {
    id: 'PC_SPEC_SPECIES_Porcine_milliplex',
    defaultMessage: 'Porcine',
  },
  PC_SPEC_SPECIES_Non_Human_Primate_milliplex: {
    id: 'PC_SPEC_SPECIES_Non_Human_Primate_milliplex',
    defaultMessage: 'Non-Human Primate',
  },
  PC_SPEC_SPECIES_Rat_milliplex: {
    id: 'PC_SPEC_SPECIES_Rat_milliplex',
    defaultMessage: 'Rat',
  },
  PC_SPEC_RESEARCH_AREAS_Bone_Metabolism_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Bone_Metabolism_milliplex',
    defaultMessage: 'Bone Metabolism',
  },
  PC_SPEC_RESEARCH_AREAS_Cancer_Angiogenesis_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cancer_Angiogenesis_milliplex',
    defaultMessage: 'Cancer/Angiogenesis',
  },
  PC_SPEC_RESEARCH_AREAS_Cancer_Immuno_oncology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cancer_Immuno_oncology_milliplex',
    defaultMessage: 'Cancer/Immuno-oncology',
  },
  PC_SPEC_RESEARCH_AREAS_Cardiovascular_Disease_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cardiovascular_Disease_milliplex',
    defaultMessage: 'Cardiovascular Disease',
  },
  PC_SPEC_RESEARCH_AREAS_Immunology_Inflammation_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Immunology_Inflammation_milliplex',
    defaultMessage: 'Immunology/Inflammation',
  },
  PC_SPEC_RESEARCH_AREAS_Cell_Signaling_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cell_Signaling_milliplex',
    defaultMessage: 'Cell Signaling',
  },
  PC_SPEC_RESEARCH_AREAS_Metabolism_Endocrinology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Metabolism_Endocrinology_milliplex',
    defaultMessage: 'Metabolism/Endocrinology',
  },
  PC_SPEC_RESEARCH_AREAS_Neuroscience_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Neuroscience_milliplex',
    defaultMessage: 'Neuroscience',
  },
  PC_SPEC_RESEARCH_AREAS_Toxicity_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Toxicity_milliplex',
    defaultMessage: 'Toxicity',
  },
  PC_SPEC_PHYSICAL_MATERIAL_DNA: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_DNA',
    defaultMessage: 'Plasmid DNA',
  },
  PC_SPEC_PHYSICAL_MATERIAL_VIRUS: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_VIRUS',
    defaultMessage: 'Lentivirus',
  },
  PC_SPEC_PHYSICAL_MATERIAL_SRNA: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_SRNA',
    defaultMessage: 'Synthetic RNA',
  },
  PC_SPEC_PHYSICAL_MATERIAL_VITRO: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_VITRO',
    defaultMessage: 'In vitro transcribed RNA(IVT RNA)',
  },
  PC_SPEC_VECTOR_LV01: {
    id: 'PC_SPEC_VECTOR_LV01',
    defaultMessage:
      '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV02: {
    id: 'PC_SPEC_VECTOR_LV02',
    defaultMessage:
      '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV03: {
    id: 'PC_SPEC_VECTOR_LV03',
    defaultMessage:
      '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV04: {
    id: 'PC_SPEC_VECTOR_LV04',
    defaultMessage:
      '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV05: {
    id: 'PC_SPEC_VECTOR_LV05',
    defaultMessage:
      '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV06: {
    id: 'PC_SPEC_VECTOR_LV06',
    defaultMessage:
      '(LV06) U6-gRNA-MS2:ef1a-puro (SAM Activator:puro lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV07: {
    id: 'PC_SPEC_VECTOR_LV07',
    defaultMessage:
      '(LV07) U6-gRNA-MS2:ef1a-zeo (SAM Activator:zeo lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV08: {
    id: 'PC_SPEC_VECTOR_LV08',
    defaultMessage: '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  },
  PC_SPEC_VECTOR_LV13: {
    id: 'PC_SPEC_VECTOR_LV013',
    defaultMessage:
      '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  },
  PC_SPEC_VECTOR_LV14: {
    id: 'PC_SPEC_VECTOR_LV014',
    defaultMessage: "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  },
  PC_SPEC_VECTOR_LV15: {
    id: 'PC_SPEC_VECTOR_LV015',
    defaultMessage:
      '(LV15) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, stem-loop position)',
  },
  PC_SPEC_VECTOR_LV16: {
    id: 'PC_SPEC_VECTOR_LV016',
    defaultMessage: "(LV16) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, 3' position)",
  },
  PC_SPEC_VECTOR_LV17: {
    id: 'PC_SPEC_VECTOR_LV017',
    defaultMessage:
      '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  },
  PC_SPEC_VECTOR_p01: {
    id: 'PC_SPEC_VECTOR_p01',
    defaultMessage: '(p01) U6-gRNA:CMV-Cas9-2a-tGFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p02: {
    id: 'PC_SPEC_VECTOR_p02',
    defaultMessage: '(p02) U6-gRNA:CMV-Cas9-2A-tRFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p03: {
    id: 'PC_SPEC_VECTOR_p03',
    defaultMessage: '(p03) U6-gRNA (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p04: {
    id: 'PC_SPEC_VECTOR_p04',
    defaultMessage: '(p04) U6-gRNA:CMV-eCas9-2a-tGFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p05: {
    id: 'PC_SPEC_VECTOR_p05',
    defaultMessage: '(p05) U6-gRNA:CMV-eCas9-2a-tRFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p10: {
    id: 'PC_SPEC_VECTOR_p10',
    defaultMessage: 'p10 CRISPRBACD J23119-gRNA-amp (bacterial plasmid)',
  },
  PC_SPEC_VECTOR_p11: { id: 'PC_SPEC_VECTOR_p11', defaultMessage: '(p11) BBB' },
  PC_SPEC_VECTOR_p50: {
    id: 'PC_SPEC_VECTOR_p50',
    defaultMessage:
      'p50 (monocot) U6-gRNA:CMV-Cas9-hyg (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p51: {
    id: 'PC_SPEC_VECTOR_p51',
    defaultMessage:
      'p51 (monocot)U6-gRNA:CMV-Cas9-neo (Agrobacterium plasmid) ',
  },
  PC_SPEC_VECTOR_p52: {
    id: 'PC_SPEC_VECTOR_p52',
    defaultMessage: 'p52 (monocot)U6-gRNA:CMV-Cas9-bar (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p53: {
    id: 'PC_SPEC_VECTOR_p53',
    defaultMessage: 'p53 (dicot)U6-gRNA:CMV-Cas9-hyg (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p54: {
    id: 'PC_SPEC_VECTOR_p54',
    defaultMessage: 'p54 (dicot)U6-gRNA:CMV-Cas9-neo (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p55: {
    id: 'PC_SPEC_VECTOR_p55',
    defaultMessage: 'p55 (dicot)U6-gRNA:CMV-Cas9-bar (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p56: {
    id: 'PC_SPEC_VECTOR_p56',
    defaultMessage: 'p56 (monocot)U6-gRNA:CMV-Cas9-hyg (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p57: {
    id: 'PC_SPEC_VECTOR_p57',
    defaultMessage: 'p57 (monocot)U6-gRNA:CMV-Cas9-neo (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p58: {
    id: 'PC_SPEC_VECTOR_p58',
    defaultMessage: 'p58 (monocot)U6-gRNA:CMV-Cas9-bar (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p59: {
    id: 'PC_SPEC_VECTOR_p59',
    defaultMessage: 'p59	(dicot)U6-gRNA:CMV-Cas9-hyg (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p60: {
    id: 'PC_SPEC_VECTOR_p60',
    defaultMessage: 'p60 (dicot)U6-gRNA:CMV-Cas9-neo (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p61: {
    id: 'PC_SPEC_VECTOR_p61',
    defaultMessage: 'p61	(dicot)U6-gRNA:CMV-Cas9-bar (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p62: {
    id: 'PC_SPEC_VECTOR_p62',
    defaultMessage:
      'p62	(monocot)U6-gRNA:CMV-Cas9-beta glucaronidase (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p63: {
    id: 'PC_SPEC_VECTOR_p63',
    defaultMessage:
      'p63	(dicot)U6-gRNA:CMV-Cas9-beta glucuronidase (Agrobacterium plasmid)',
  },
  PC_SPEC_AMOUNT_1_UG: { id: 'PC_SPEC_AMOUNT_1_UG', defaultMessage: '1 µg' },
  PC_SPEC_AMOUNT_10_UG: { id: 'PC_SPEC_AMOUNT_10_UG', defaultMessage: '10 µg' },
  PC_SPEC_AMOUNT_25_UG: { id: 'PC_SPEC_AMOUNT_25_UG', defaultMessage: '25 µg' },
  PC_SPEC_AMOUNT_100_UG: {
    id: 'PC_SPEC_AMOUNT_100_UG',
    defaultMessage: '100 µg',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV01: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV01',
    defaultMessage:
      '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV02: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV02',
    defaultMessage: '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV03: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV03',
    defaultMessage: '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV04: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV04',
    defaultMessage: '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV05: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV05',
    defaultMessage:
      '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV06: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV06',
    defaultMessage:
      '(LV06) U6-gRNA-MS2:ef1a-puro (SAM Activator:puro lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV07: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV07',
    defaultMessage:
      '(LV07) U6-gRNA-MS2:ef1a-zeo (SAM Activator:zeo lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV08: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV08',
    defaultMessage: '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV13: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV13',
    defaultMessage:
      '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV14: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV14',
    defaultMessage: "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV15: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV15',
    defaultMessage:
      '(LV15) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, stem-loop position)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV16: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV16',
    defaultMessage: "(LV16) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, 3' position)",
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV17: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV17',
    defaultMessage:
      '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  },
  PC_SPEC_ALIQUOTING_1_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_1_INTO_200_UL',
    defaultMessage: '1 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_100_UL',
    defaultMessage: '10 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_20_UL',
    defaultMessage: '10 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_200_UL',
    defaultMessage: '10 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_100_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_100_INTO_20_UL',
    defaultMessage: '100 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_100_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_100_INTO_50_UL',
    defaultMessage: '100 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_2_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_2_INTO_100_UL',
    defaultMessage: '2 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_2_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_2_INTO_50_UL',
    defaultMessage: '2 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_20_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_20_INTO_100_UL',
    defaultMessage: '20 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_20_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_20_INTO_50_UL',
    defaultMessage: '20 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_200_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_200_INTO_25_UL',
    defaultMessage: '200 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_25_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_25_INTO_200_UL',
    defaultMessage: '25 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_4_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_4_INTO_25_UL',
    defaultMessage: '4 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_4_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_4_INTO_50_UL',
    defaultMessage: '4 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_40_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_40_INTO_25_UL',
    defaultMessage: '40 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_40_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_40_INTO_50_UL',
    defaultMessage: '40 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_5_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_5_INTO_20_UL',
    defaultMessage: '5 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_5_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_5_INTO_200_UL',
    defaultMessage: '5 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_50_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_50_INTO_100_UL',
    defaultMessage: '50 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_50_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_50_INTO_20_UL',
    defaultMessage: '50 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_8_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_8_INTO_25_UL',
    defaultMessage: '8 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_80_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_80_INTO_25_UL',
    defaultMessage: '80 x 25 µl',
  },
  PC_SPEC_VOLUME_0_1_ml: {
    id: 'PC_SPEC_VOLUME_0_1_ml',
    defaultMessage: '100 µl',
  },
  PC_SPEC_VOLUME_0_2_ml: {
    id: 'PC_SPEC_VOLUME_0_2_ml',
    defaultMessage: '200 µl',
  },
  PC_SPEC_VOLUME_1_0_ml: {
    id: 'PC_SPEC_VOLUME_1_0_ml',
    defaultMessage: '1 ml',
  },
  PC_SPEC_VOLUME_2_0_ml: {
    id: 'PC_SPEC_VOLUME_2_0_ml',
    defaultMessage: '2 ml',
  },
  PC_SPEC_VOLUME_5_0_ml: {
    id: 'PC_SPEC_VOLUME_5_0_ml',
    defaultMessage: '5 ml',
  },
  PC_SPEC_VIRAL_TITER_10_6: {
    id: 'PC_SPEC_VIRAL_TITER_10_6',
    defaultMessage: '10^6 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_7: {
    id: 'PC_SPEC_VIRAL_TITER_10_7',
    defaultMessage: '10^7 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_8: {
    id: 'PC_SPEC_VIRAL_TITER_10_8',
    defaultMessage: '10^8 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_9: {
    id: 'PC_SPEC_VIRAL_TITER_10_9',
    defaultMessage: '10^9 particles/ml',
  },
  PC_SPEC_SPCAS9: { id: 'PC_SPEC_SPCAS9', defaultMessage: 'SpCas9' },
  PC_SPEC_FNCAS9: {
    id: 'PC_SPEC_FNCAS9',
    defaultMessage: 'FnCas9 (For non-cellular, synthetic applications)',
  },
  PC_SPEC_CRRNA: {
    id: 'PC_SPEC_CRRNA',
    defaultMessage: 'crRNA (tracrRNA sold separately)',
  },
  PC_SPEC_SYGRNA: {
    id: 'PC_SPEC_SYGRNA',
    defaultMessage: 'sgRNA (crRNA + tracrRNA as one)',
  },
  PC_SPEC_3_0NM: { id: 'PC_SPEC_3_0NM', defaultMessage: '3 nmol' },
  PC_SPEC_AMOUNT_5MG: { id: 'PC_SPEC_AMOUNT_5MG', defaultMessage: '5 mg' },
  PC_SPEC_AMOUNT_10MG: { id: 'PC_SPEC_AMOUNT_10MG', defaultMessage: '10 mg' },
  PC_SPEC_CARRIER_PROTIENKLH_antisera: {
    id: 'PC_SPEC_CARRIER_PROTIENKLH_antisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_CARRIER_PROTIENBSA_antisera: {
    id: 'PC_SPEC_CARRIER_PROTIENBSA_antisera',
    defaultMessage: 'BSA',
  },
  PC_SPEC_PURITY_GT70_antisera: {
    id: 'PC_SPEC_PURITY_GT70_antisera',
    defaultMessage: '>70',
  },
  PC_SPEC_PURITY_GT80_antisera: {
    id: 'PC_SPEC_PURITY_GT80_antisera',
    defaultMessage: '>80',
  },
  PC_SPEC_PURITY_GT90_antisera: {
    id: 'PC_SPEC_PURITY_GT90_antisera',
    defaultMessage: '>90',
  },
  PC_SPEC_PURITY_GT95_antisera: {
    id: 'PC_SPEC_PURITY_GT95_antisera',
    defaultMessage: '>95',
  },
  PC_SPEC_PURITY_IMMUNOLOGICAL_antisera: {
    id: 'PC_SPEC_PURITY_IMMUNOLOGICAL_antisera',
    defaultMessage: 'Immunological',
  },
  PC_SPEC_CTERM_OH_Carboxyl_antisera: {
    id: 'PC_SPEC_CTERM_OH_Carboxyl_antisera',
    defaultMessage: '[OH]=Carboxyl',
  },
  PC_SPEC_CTERM_NH2_Amidation_antisera: {
    id: 'PC_SPEC_CTERM_NH2_Amidation_antisera',
    defaultMessage: '[NH2]=Amidation',
  },
  PC_SPEC_INTERNALMOD_pTyr_phosphotyrosine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pTyr_phosphotyrosine_antisera',
    defaultMessage: '[pTyr]phosphotyrosine',
  },
  PC_SPEC_INTERNALMOD_pThr_Phosphothreonine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pThr_Phosphothreonine_antisera',
    defaultMessage: '[pThr]Phosphothreonine',
  },
  PC_SPEC_INTERNALMOD_Ahx_Aminohexanoicacid_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Ahx_Aminohexanoicacid_antisera',
    defaultMessage: '[Ahx]Aminohexanoic acid',
  },
  PC_SPEC_INTERNALMOD_pSer_Phosphoserine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pSer_Phosphoserine_antisera',
    defaultMessage: '[pSer]Phosphoserine',
  },
  PC_SPEC_INTERNALMOD_Kme1_mono_Methyl_Lysine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Kme1_mono_Methyl_Lysine_antisera',
    defaultMessage: '[Kme]mono-Methyl-Lysine',
  },
  PC_SPEC_INTERNALMOD_Kme2_di_Methyl_Lysine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Kme2_di_Methyl_Lysine_antisera',
    defaultMessage: '[Kme2]di-Methyl-Lysine',
  },
  PC_SPEC_NTERM_H_Amine_antisera: {
    id: 'PC_SPEC_NTERM_H_Amine_antisera',
    defaultMessage: '[H]=Amine',
  },
  PC_SPEC_NTERM_Ace_Acetylation_antisera: {
    id: 'PC_SPEC_NTERM_Ace_Acetylation_antisera',
    defaultMessage: '[Ace]=Acetylation',
  },
  PC_SPEC_PSA: {
    id: 'PC_SPEC_PSA',
    defaultMessage: 'Peptide synthesis and antisera',
  },
  PC_SPEC_CSAA: {
    id: 'PC_SPEC_CSAA',
    defaultMessage: 'Customer supplied antigen and antisera',
  },
  PC_SPEC_SELECT_PEPTIDE1_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE1_antisera',
    defaultMessage: 'Peptide1',
  },
  PC_SPEC_SELECT_PEPTIDE2_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE2_antisera',
    defaultMessage: 'Peptide2',
  },
  PC_SPEC_SELECT_PEPTIDE3_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE3_antisera',
    defaultMessage: 'Peptide3',
  },
  PC_SPEC_SELECT_PEPTIDE123_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE123_antisera',
    defaultMessage: 'Peptide1+2+3',
  },
  PC_SPEC_SELECT_PEPTIDE12_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE12_antisera',
    defaultMessage: 'Peptide1+2',
  },
  PC_SPEC_SELECT_PEPTIDE_CUST_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE_CUST_antisera',
    defaultMessage: 'Customer Supplied Antigen',
  },
  PC_SPEC_SELECT_PEPTIDE23_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE23_antisera',
    defaultMessage: 'Peptide2+3',
  },
  PC_SPEC_SELECT_PEPTIDE13_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE13_antisera',
    defaultMessage: 'Peptide1+3',
  },
  PC_SPEC_Rabbit_antisera: {
    id: 'PC_SPEC_Rabbit_antisera',
    defaultMessage: 'Rabbit',
  },
  PC_SPEC_Mouse_antisera: {
    id: 'PC_SPEC_Mouse_antisera',
    defaultMessage: 'Mouse',
  },
  PC_SPEC_Rat_antisera: { id: 'PC_SPEC_Rat_antisera', defaultMessage: 'Rat' },
  PC_SPEC_Chicken_antisera: {
    id: 'PC_SPEC_Chicken_antisera',
    defaultMessage: 'Chicken',
  },
  PC_SPEC_NOANIMALS1_antisera: {
    id: 'PC_SPEC_NOANIMALS1_antisera',
    defaultMessage: '1',
  },
  PC_SPEC_NOANIMALS2_antisera: {
    id: 'PC_SPEC_NOANIMALS2_antisera',
    defaultMessage: '2',
  },
  PC_SPEC_NOANIMALS3_antisera: {
    id: 'PC_SPEC_NOANIMALS3_antisera',
    defaultMessage: '3',
  },
  PC_SPEC_NOANIMALS5_antisera: {
    id: 'PC_SPEC_NOANIMALS5_antisera',
    defaultMessage: '5',
  },
  PC_SPEC_IMMUN_TERM49_antisera: {
    id: 'PC_SPEC_IMMUN_TERM49_antisera',
    defaultMessage: '49 Days',
  },
  PC_SPEC_IMMUN_TERM63_antisera: {
    id: 'PC_SPEC_IMMUN_TERM63_antisera',
    defaultMessage: '63 Days',
  },
  PC_SPEC_IMMUN_TERM56_antisera: {
    id: 'PC_SPEC_IMMUN_TERM56_antisera',
    defaultMessage: '56 Days',
  },
  PC_SPEC_IMMUN_TERM77_antisera: {
    id: 'PC_SPEC_IMMUN_TERM77_antisera',
    defaultMessage: '77 Days',
  },
  PC_SPEC_PURIFIC_TYPE_AFF10_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF10_antisera',
    defaultMessage: 'Affinity (Pep - 10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF20_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF20_antisera',
    defaultMessage: 'Affinity (Pep - 20ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF30_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF30_antisera',
    defaultMessage: 'Affinity (Pep - 30ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF40_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF40_antisera',
    defaultMessage: 'Affinity (Pep - 40ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF50_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF50_antisera',
    defaultMessage: 'Affinity (Pep - 50ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO10_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO10_antisera',
    defaultMessage: 'Protein A (10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO20_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO20_antisera',
    defaultMessage: 'Protein A (20ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO30_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO30_antisera',
    defaultMessage: 'Protein A (30ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO40_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO40_antisera',
    defaultMessage: 'Protein A (40ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO50_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO50_antisera',
    defaultMessage: 'Protein A (50ml Antisera)',
  },
  PC_SPEC_NONE_antisera: {
    id: 'PC_SPEC_NONE_antisera',
    defaultMessage: 'None',
  },
  PC_SPEC_COLUMN_NO1_antisera: {
    id: 'PC_SPEC_COLUMN_NO1_antisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_COLUMN_NO2_antisera: {
    id: 'PC_SPEC_COLUMN_NO2_antisera',
    defaultMessage: 'Column 2',
  },
  PC_SPEC_COLUMN_NO3_antisera: {
    id: 'PC_SPEC_COLUMN_NO3_antisera',
    defaultMessage: 'Column 3',
  },
  PC_SPEC_CTERM_OH_Carboxyl_simpleantisera: {
    id: 'PC_SPEC_CTERM_OH_Carboxyl_simpleantisera',
    defaultMessage: '[OH]=Carboxyl',
  },
  PC_SPEC_CTERM_NH2_Amidation_simpleantisera: {
    id: 'PC_SPEC_CTERM_NH2_Amidation_simpleantisera',
    defaultMessage: '[NH2]=Amidation',
  },
  PC_SPEC_NTERM_H_Amine_simpleantisera: {
    id: 'PC_SPEC_NTERM_H_Amine_simpleantisera',
    defaultMessage: '[H]=Amine',
  },
  PC_SPEC_NTERM_Ace_Acetylation_simpleantisera: {
    id: 'PC_SPEC_NTERM_Ace_Acetylation_simpleantisera',
    defaultMessage: '[Ace]=Acetylation',
  },
  PC_SPEC_CARRIER_PROTIENKLH_simpleantisera: {
    id: 'PC_SPEC_CARRIER_PROTIENKLH_simpleantisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_PURIFIC_TYPE_1_simpleantisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_1_simpleantisera',
    defaultMessage: 'Affinity (Pep - 10ml Antisera)',
  },
  PC_SPEC_ANTIGEN_COLUMN: {
    id: 'PC_SPEC_ANTIGEN_COLUMN',
    defaultMessage: 'Antigen for Column 1 Preparation',
  },
  PC_SPEC_COLUMN_NO1_simpleantisera: {
    id: 'PC_SPEC_COLUMN_NO1_simpleantisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_PROJECT_TYPE_PEPTIDE_SYNTH_antisera: {
    id: 'PC_SPEC_PROJECT_TYPE_PEPTIDE_SYNTH_antisera',
    defaultMessage: 'Peptide synthesis and antisera',
  },
  PC_SPEC_PROJECT_TYPE_CUSTOMER_SUPPLIED_antisera: {
    id: 'PC_SPEC_PROJECT_TYPE_CUSTOMER_SUPPLIED_antisera',
    defaultMessage: 'Customer supplied antigen and antisera',
  },
  PC_SPEC_PURITY_IMMUNOLOGICAL_simpleantisera: {
    id: 'PC_SPEC_PURITY_IMMUNOLOGICAL_simpleantisera',
    defaultMessage: 'Immunological',
  },
  PC_SPEC_Rabbit_simpleantisera: {
    id: 'PC_SPEC_Rabbit_simpleantisera',
    defaultMessage: 'Rabbit',
  },
  PC_SPEC_NOANIMALS1_simpleantisera: {
    id: 'PC_SPEC_NOANIMALS1_simpleantisera',
    defaultMessage: ' 1',
  },
  PC_SPEC_IMMUN_TERM56_simpleantisera: {
    id: 'PC_SPEC_IMMUN_TERM56_simpleantisera',
    defaultMessage: '56 days',
  },
  PC_SPEC_SELECT_COL1_antisera: {
    id: 'PC_SPEC_SELECT_COL1_antisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_SELECT_KLH_antisera: {
    id: 'PC_SPEC_SELECT_KLH_antisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_SELECT_COL2_antisera: {
    id: 'PC_SPEC_SELECT_COL2_antisera',
    defaultMessage: 'Column 2',
  },
  PC_SPEC_SELECT_COL3_antisera: {
    id: 'PC_SPEC_SELECT_COL3_antisera',
    defaultMessage: 'Column 3',
  },
  PC_SPEC_SELECT_antisera: {
    id: 'PC_SPEC_SELECT_antisera',
    defaultMessage: 'Select',
  },
  PC_SPEC_PURIFIC_TYPE_1_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_1_antisera',
    defaultMessage: 'Affinity(Peptide -10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_2_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_2_antisera',
    defaultMessage: 'Protien A (5ml Antisera)',
  },
  PC_SPEC_SARS_CoV_2NucleoProN: {
    id: 'PC_SPEC_SARS_CoV_2NucleoProN',
    defaultMessage: 'SARS-CoV-2 Nucleocapsid Protein (N)',
  },
  PC_SPEC_SARS_CoV_2RBD: {
    id: 'PC_SPEC_SARS_CoV_2RBD',
    defaultMessage: 'SARS-CoV-2 Receptor Binding Domain(RBD)',
  },
  PC_SPEC_SARS_CoV_2S1: {
    id: 'PC_SPEC_SARS_CoV_2S1',
    defaultMessage: 'SARS-CoV-2 Spike S1',
  },
  PC_SPEC_SARS_CoV_2S2: {
    id: 'PC_SPEC_SARS_CoV_2S2',
    defaultMessage: 'SARS-CoV-2 Spike S2',
  },
  PC_SPEC_4_1BBL_TNFSF9: {
    id: 'PC_SPEC_4_1BBL_TNFSF9',
    defaultMessage: '4-1BBL/TNFSF9',
  },
  PC_SPEC_APRIL: { id: 'PC_SPEC_APRIL', defaultMessage: 'APRIL' },
  PC_SPEC_B7_H2_ICOSL: {
    id: 'PC_SPEC_B7_H2_ICOSL',
    defaultMessage: 'B7-H2/ICOSL',
  },
  PC_SPEC_B7_H3_CD276: {
    id: 'PC_SPEC_B7_H3_CD276',
    defaultMessage: 'B7-H3/CD276',
  },
  PC_SPEC_B7_H4_VTCN1: {
    id: 'PC_SPEC_B7_H4_VTCN1',
    defaultMessage: 'B7-H4/VTCN1',
  },
  PC_SPEC_B7_H5_VISTA: {
    id: 'PC_SPEC_B7_H5_VISTA',
    defaultMessage: 'B7-H5/VISTA',
  },
  PC_SPEC_B7_H6: { id: 'PC_SPEC_B7_H6', defaultMessage: 'B7-H6' },
  PC_SPEC_CD226_DNAM_1: {
    id: 'PC_SPEC_CD226_DNAM_1',
    defaultMessage: 'CD226/DNAM-1',
  },
  PC_SPEC_E_Cadherin: {
    id: 'PC_SPEC_E_Cadherin',
    defaultMessage: 'E-Cadherin',
  },
  PC_SPEC_FGL1_Hepassocin: {
    id: 'PC_SPEC_FGL1_Hepassocin',
    defaultMessage: 'FGL1/Hepassocin',
  },
  PC_SPEC_Granulysin: {
    id: 'PC_SPEC_Granulysin',
    defaultMessage: 'Granulysin',
  },
  PC_SPEC_IDO1: { id: 'PC_SPEC_IDO1', defaultMessage: 'IDO1' },
  PC_SPEC_MICA: { id: 'PC_SPEC_MICA', defaultMessage: 'MICA' },
  PC_SPEC_MICB: { id: 'PC_SPEC_MICB', defaultMessage: 'MICB' },
  PC_SPEC_Nectin_2: { id: 'PC_SPEC_Nectin_2', defaultMessage: 'Nectin-2' },
  PC_SPEC_Nectin_4: { id: 'PC_SPEC_Nectin_4', defaultMessage: 'Nectin-4' },
  PC_SPEC_OX40_CD134: {
    id: 'PC_SPEC_OX40_CD134',
    defaultMessage: 'OX40/CD134',
  },
  PC_SPEC_PVR_CD155: { id: 'PC_SPEC_PVR_CD155', defaultMessage: 'PVR/CD155' },
  PC_SPEC_Siglec_7: { id: 'PC_SPEC_Siglec_7', defaultMessage: 'Siglec-7' },
  PC_SPEC_Siglec_9: { id: 'PC_SPEC_Siglec_9', defaultMessage: 'Siglec-9' },
  PC_SPEC_RESEARCH_AREAS_Virology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Virology_milliplex',
    defaultMessage: 'Virology',
  },
  PC_SPEC_SPECIES_Ovine_milliplex: {
    id: 'PC_SPEC_SPECIES_Ovine_milliplex',
    defaultMessage: 'Ovine',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF10: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF10',
    defaultMessage: 'Absorption Affinity 10 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF20: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF20',
    defaultMessage: 'Absorption Affinity 20 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF30: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF30',
    defaultMessage: 'Absorption Affinity 30 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF40: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF40',
    defaultMessage: 'Absorption Affinity 40 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF50: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF50',
    defaultMessage: 'Absorption Affinity 50 ml',
  },
  KSPRA2015_HEX: { id: 'KSPRA2015_HEX', defaultMessage: 'HEX' },
  KSPRA2015_FAM: { id: 'KSPRA2015_FAM', defaultMessage: 'FAM' },
  NO_DATA_FOUND: {
    id: 'NO_DATA_FOUND',
    defaultMessage: 'No Data found',
  },
})

export default messages
